// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/bg-top.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-chat-area {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background: #fff;
    min-width: 0;
    position: relative;
    transition: all 0.3s ease-in-out;
  }
  
  .hero-messages {
    flex: 1 1;
    overflow-y: auto;
    padding: 32px 0 50px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    position: relative;
    height: 65vh;
    max-height: 100%;
    scroll-behavior: smooth;
    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    /* Hide scrollbar */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
  }
  
  /* Hide scrollbar for WebKit browsers (Chrome, Safari, Edge) */
  .hero-messages::-webkit-scrollbar {
    display: none;
  }
  
  .hero-messages.with-content {
    padding: 16px 0 50px 0;
  }
  
  .hero-message {
    max-width: 1300px;
    width: 60%;
    font-size: 1.1rem;
    line-height: 1.6;
    word-break: break-word;
    display: block;
    box-shadow: none;
    border: none;
    padding: 0;
    background: none;
    color: #17202B;
    margin-left: auto;
    margin-right: auto;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateY(0);
    opacity: 1;
  }
  
  /* Responsive width adjustments for messages */
  @media (max-width: 1199px) {
    .hero-message, .hero-message.user, .hero-message.ai {
      width: 80%;
    }
  }
  
  @media (max-width: 899px) {
    .hero-message, .hero-message.user, .hero-message.ai {
      width: 90%;
    }
  }
  
  @media (max-width: 767px) {
    .hero-message, .hero-message.user, .hero-message.ai {
      width: 95%;
    }
  }
  
  @media (max-width: 599px) {
    .hero-message, .hero-message.user, .hero-message.ai {
      width: 98%;
    }
  }
  
  @media (max-width: 479px) {
    .hero-message, .hero-message.user, .hero-message.ai {
      width: 99%;
    }
  }
  
  .hero-message.entering {
    transform: translateY(20px);
    opacity: 0;
  }
  
  .hero-message.user {
    border-radius: 15px;
    padding: 10px 0px;
    margin-top: 8px;
    margin-bottom: 4px;
    padding-top: 14px;
    padding-bottom: 14px;
    color: #17202B;
    display: flex;
    justify-content: flex-end;
    margin-left: 0px; /* leave space on left for AI avatar */
    margin-right: 0;
  }
  
  .hero-user-message-content {
    text-align: right;
    font-size: 16px;
    color: #17202B;
    border-radius: 15px;
    max-width: 520px;
    min-width: 0;
    align-self: flex-end;
    width: fit-content;
    margin-left: auto;
    padding: 18px 18px;
    border: 1px solid #D5D5D5;
  }
  
  .hero-message.user .hero-copy-btn {
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.18s;
  }
  
  .hero-message.user:hover .hero-copy-btn,
  .hero-message.user:focus-within .hero-copy-btn {
    opacity: 1;
    pointer-events: auto;
  }
  
  .hero-message.ai {
    background: none;
    border-radius: 23px;
    box-shadow: none;
    padding: 10px 28px;
    margin-top: 8px;
    color: #17202B;
    max-width: 1300px;
    width: 60%;
    margin-left: 0;
    margin-right: 0;
    text-align: left;
    background: #fff;
    color: #222;
    border-radius: 15px;
    padding: 18px 18px;
    min-width: 0;
    box-shadow: 0 1px 4px rgba(0,0,0,0.04);
    margin-bottom: 4px;
    align-self: flex-start;
    display: block;
    width: fit-content;
  }
  
  .hero-input-area {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    background: none;
    border: none;
    box-shadow: none;
    margin: 0 auto 0px auto;
    max-width: 600px;
    width: 100%;
    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateY(0);
    opacity: 1;
  }
  
  .hero-input-area {
    margin-top: 0;
  }
  
  .hero-input-area.with-messages {
    margin-top: 16px;
    margin-bottom: 16px;
    transform: translateY(0);
    opacity: 1;
  }
  
  .hero-input-area.initial-state {
    transform: translateY(20px);
    opacity: 0.8;
  }
  
  .hero-chat-input:focus {
    border: 1.5px solid #2F80ED;
    background: #fff;
    box-shadow: 0 4px 16px rgba(47,128,237,0.10);
  }

  .hero-top-section{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    min-height: 100vh;
    width: 100%;
    position: relative;
  }
  .hero-top-section-white{
    background: #ffffff;
    min-height: 100vh;
    width: 100%;
    position: relative;
  }
  
  .hero-empty-center-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    min-height: 100vh;
    width: 100%;
    background: none;
    padding-top: 30vh;
    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 1;
    transform: translateY(0);
  }
  
  .hero-empty-center-wrapper.fading {
    opacity: 0;
    transform: translateY(-20px);
  }
  
  /* Add animation for headline text that appears for 1.2 seconds then disappears */
  @keyframes headline-fade-in-out {
    0% {
      opacity: 0;
      transform: translateY(10px);
    }
    10% {
      opacity: 1;
      transform: translateY(0);
    }
    80% {
      opacity: 1;
      transform: translateY(0);
    }
    100% {
      opacity: 0;
      transform: translateY(-10px);
    }
  }

.hero-empty-chat-headline {
  text-align: center;
  font-size: 24px;
  font-weight: 400;
  color: #fff;
  margin-bottom: 20px;
  letter-spacing: -0.5px;
  line-height: 60px;
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.hero-new-text-above-headline {
  text-align: center;
  font-size: 24px;
  font-weight: 400;
  color: #fff;
  margin-bottom: 2rem;
  letter-spacing: -0.5px;
  line-height: 1.2;
  animation: headline-fade-in-out 5s ease-in-out;
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.hero-new-text-above-headline.hidden {
  opacity: 0;
  transform: translateY(-10px);
  pointer-events: none;
}
  
  .hero-bot-picker-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 0;
    margin-top: 32px;
    margin-bottom: 18px;
    background: none;
    border-top: none;
    border-bottom: none;
    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 1;
    transform: translateY(0);
  }
  
  .hero-bot-picker-row.fading {
    opacity: 0;
    transform: translateY(-10px);
  }
  
  .hero-bot-picker-btn {
    background: #EEECF9;
    color: #2F80ED;
    border: none;
    border-radius: 999px;
    padding: 8px 20px;
    font-size: 1rem;
    font-weight: 500;
    margin-right: 6px;
    cursor: pointer;
    transition: background 0.18s, color 0.18s, box-shadow 0.18s;
    box-shadow: 0 1px 4px rgba(23,32,43,0.04);
    outline: none;
    position: relative;
  }
  
  .hero-bot-picker-btn:last-child {
    margin-right: 0;
  }
  
  .hero-bot-picker-btn:hover:not(:disabled), .hero-bot-picker-btn:focus:not(:disabled) {
    background: #2654FF1A;
    color: #EEECF9;
    box-shadow: 0 2px 8px rgba(47,128,237,0.08);
  }
  
  .hero-bot-picker-btn.active {
    background: #2654FF1A;
    color: #EEECF9;
    font-weight: bold;
    box-shadow: 0 4px 16px rgba(47,128,237,0.10);
  }
  
  .hero-bot-picker-btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
  
  .hero-bot-btn-tooltip-wrapper {
    position: relative;
    display: inline-block;
  }
  
  .hero-bot-tooltip {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    left: 50%;
    top: 120%;
    transform: translateX(-50%);
    background: #EEECF9;
    color: #17202B;
    padding: 7px 16px;
    border-radius: 8px;
    font-size: 0.98rem;
    font-weight: 500;
    white-space: nowrap;
    pointer-events: none;
    z-index: 10;
    box-shadow: 0 2px 8px rgba(23,32,43,0.10);
    transition: opacity 0.18s, visibility 0.18s;
    max-width: 250px;
    width: 250%;
    word-wrap: break-word;
    white-space: normal;
    text-align: center;
  }
  
.hero-disclaimer-text {
  font-size: 14px;
  color: #fff;
  text-align: center;
  width: 60%;
  max-width: 1300px;
  margin: 0 auto;
}

.hero-disclaimer-text-messages {
    font-size: 14px;
    color: rgba(181, 181, 181, 1);
    text-align: center;
    width: 60%;
    max-width: 1300px;
    margin: 0 auto;
}
  
  /* Responsive width adjustments for disclaimer text */
  @media (max-width: 1199px) {
    .hero-disclaimer-text {
      width: 80%;
    }
  }
  
  @media (max-width: 899px) {
    .hero-disclaimer-text {
      width: 90%;
      font-size: 13px;
    }
  }
  
  @media (max-width: 767px) {
    .hero-disclaimer-text {
      width: 95%;
      font-size: 12px;
    }
  }
  
  @media (max-width: 599px) {
    .hero-disclaimer-text {
      width: 98%;
      font-size: 11px;
    }
  }
  
  @media (max-width: 479px) {
    .hero-disclaimer-text {
      width: 99%;
      font-size: 10px;
    }
  }
  
  @media (max-width: 319px) {
    .hero-disclaimer-text {
      width: 100%;
      font-size: 9px;
    }
  }
  
  .hero-tooltip-title {
    display: block;
    font-weight: 600;
    margin-bottom: 5px;
  }
  
  .hero-tooltip-content {
    display: block;
    font-weight: 400;
  }
  
  .hero-bot-btn-tooltip-wrapper:hover .hero-bot-tooltip {
    visibility: visible;
    opacity: 1;
  }
  
  .hero-indicator{
    width: 60%;
    max-width: 1300px;
    padding-bottom: 1rem;
  }
  
  /* Responsive width adjustments for indicator */
  @media (max-width: 1199px) {
    .hero-indicator {
      width: 80%;
    }
  }
  
  @media (max-width: 899px) {
    .hero-indicator {
      width: 90%;
    }
  }
  
  @media (max-width: 767px) {
    .hero-indicator {
      width: 95%;
    }
  }
  
  @media (max-width: 599px) {
    .hero-indicator {
      width: 98%;
    }
  }
  
  @media (max-width: 479px) {
    .hero-indicator {
      width: 99%;
    }
  }
  
  .hero-typing-indicator {
    display: inline-flex;
    align-items: flex-end;
    font-size: 1.1rem;
    color: #2F80ED;
    font-weight: 500;
    letter-spacing: 0.5px;
  }
  
  .hero-typing-indicator .hero-dot {
    display: inline-block;
    width: 4px;
    height: 4px;
    margin-left: 2px;
    margin-right: 2px;
    border-radius: 50%;
    background: #2F80ED;
    opacity: 0.7;
    animation: typing-jump 1.2s infinite both;
    position: relative;
    bottom: 5px;
  }
  
  .hero-typing-indicator .hero-dot:nth-child(2) {
    animation-delay: 0.2s;
  }
  .hero-typing-indicator .hero-dot:nth-child(3) {
    animation-delay: 0.4s;
  }
  
  @keyframes typing-jump {
    0%, 80%, 100% {
      transform: translateY(0);
      opacity: 0.7;
    }
    40% {
      transform: translateY(-8px);
      opacity: 1;
    }
  }
  
  .hero-message-actions-row {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    max-width: 1300px;
    width: 60%;
    padding: 0px 0px;
    margin: 0 auto;
  }
  
  /* Responsive width adjustments for message actions row */
  @media (max-width: 1199px) {
    .hero-message-actions-row {
      width: 80%;
    }
  }
  
  @media (max-width: 899px) {
    .hero-message-actions-row {
      width: 90%;
    }
  }
  
  @media (max-width: 767px) {
    .hero-message-actions-row {
      width: 95%;
    }
  }
  
  @media (max-width: 599px) {
    .hero-message-actions-row {
      width: 98%;
    }
  }
  
  @media (max-width: 479px) {
    .hero-message-actions-row {
      width: 99%;
    }
  }
  
  .hero-copy-btn, .hero-like-btn, .hero-dislike-btn {
    background: none;
    border: none;
    color: #b0b0b0;
    font-size: 1.1rem;
    cursor: pointer;
    padding: 2px 6px;
    border-radius: 6px;
    transition: background 0.18s, color 0.18s;
    outline: none;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .hero-copy-btn:hover, .hero-like-btn:hover, .hero-dislike-btn:hover,
  .hero-copy-btn:focus, .hero-like-btn:focus, .hero-dislike-btn:focus {
    background: #e6f0fa;
    color: #005ea2;
  }
  
  .hero-like-btn:disabled, .hero-dislike-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  .hero-feedback-thanks {
    color: #005ea2;
    font-size: 0.98rem;
    margin-left: 8px;
    opacity: 0;
    animation: feedback-fadein 0.3s forwards;
    align-self: center;
  }
  
  @keyframes feedback-fadein {
    to { opacity: 1; }
  }
  
  .hero-copy-btn-wrapper {
    position: relative;
    display: inline-block;
  }
  
  .hero-copied-tooltip {
    position: absolute;
    left: 50%;
    top: 120%;
    transform: translateX(-50%) translateY(0);
    background: #005ea2;
    color: #fff;
    padding: 3px 9px;
    border-radius: 6px;
    font-size: 0.75rem;
    font-weight: 500;
    white-space: nowrap;
    pointer-events: none;
    z-index: 10;
    opacity: 0;
    animation: copied-fadeup 1.2s;
  }
  
  .hero-tab-btn-content svg {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    margin-bottom: 3px;
    vertical-align: middle;
    display: inline-block;
  }
  
  @keyframes copied-fadeup {
    0% {
      opacity: 0;
      transform: translateX(-50%) translateY(-8px);
    }
    20% {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
    80% {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
    100% {
      opacity: 0;
      transform: translateX(-50%) translateY(8px);
    }
  }
  
  @keyframes expandDown {
    0% {
      opacity: 0;
      transform: scaleY(0);
      max-height: 0;
    }
    100% {
      opacity: 1;
      transform: scaleY(1);
      max-height: 200px;
    }
  }
  
  /* Large Desktop (1400px and above) */
  @media (min-width: 1400px) {
    .hero-message, .hero-message.user, .hero-message.ai {
      font-size: 1.2rem;
    }
    
    .hero-input-card {
      width: 70%;
      max-width: 1500px;
    }

    .hero-input-card-messages {
        width: 70%;
        max-width: 1500px;
      }
    
    .hero-action-buttons {
      width: 70%;
      max-width: 1600px;
    }
    
    .hero-empty-chat-headline {
      font-size: 24px;
    }
    
    .hero-send-btn-messages {
      font-size: 18px;
      padding: 0 20px;
      height: 52px;
    }
  }
  
  /* Desktop (1200px - 1399px) */
  @media (max-width: 1399px) and (min-width: 1200px) {
    
    .hero-input-card {
      width: 65%;
    }

    .hero-input-card-messages {
        width: 65%;
    }
    
    .hero-action-buttons {
      width: 75%;
    }
    
    .hero-send-btn-messages {
      font-size: 16px;
      padding: 0 18px;
      height: 50px;
    }
  }
  
  /* Large Tablet (900px - 1199px) */
  @media (max-width: 1199px) and (min-width: 900px) {
    .hero-message, .hero-message.user, .hero-message.ai {
      padding: 16px 16px;
      font-size: 1.05rem;
    }
  
    .hero-ai-message-wrapper + .hero-message-actions-row {
      width: 45% !important;
    }
    
    .hero-input-area {
      max-width: 85vw;
    }
    
    .hero-input-card {
      width: 80%;
      padding: 16px 24px;
    }

    .hero-input-card-messages {
        width: 80%;
        padding: 16px 24px;
    }
        
    .hero-action-buttons {
      width: 80%;
      gap: 14px;
    }
    
    .hero-action-btn {
      padding: 14px 18px;
      font-size: 0.88rem;
    }
    
    .hero-messages {
      padding: 8px 0 20px 0;
    }
    
    .hero-message-actions-row {
      padding: 16px 16px;
    }
    
    .hero-bot-picker-btn {
      padding: 7px 16px;
      font-size: 0.98rem;
    }
    
    .hero-empty-chat-headline {
      font-size: 18px;
    }
  }
  
  /* Tablet (768px - 899px) */
  @media (max-width: 899px) and (min-width: 768px) {
    .hero-message, .hero-message.user, .hero-message.ai {
      padding: 14px 14px;
      font-size: 1rem;
    }
    
    .hero-input-area {
      max-width: 90vw;
      margin: 0 auto 0 auto;
      padding: 0 1px;
    }
    
    .hero-chat-input {
      font-size: 1rem;
      padding: 14px 12px;
    }
    
    .hero-send-btn {
      font-size: 1rem;
      padding: 0 16px;
      height: 44px;
    }
    
    .hero-send-btn-messages {
      font-size: 1rem;
      padding: 0 16px;
      height: 44px;
    }
    
    .hero-messages {
      padding: 6px 0 18px 0;
      gap: 6px;
      max-width: 99%;
      align-items: center;
      overflow-y: auto;
    }
    
    .hero-bot-picker-btn {
      padding: 6px 12px;
      font-size: 0.95rem;
      margin-right: 4px;
      min-width: 0;
      height: auto;
    }
    
    .hero-message-actions-row {
      gap: 6px;
      font-size: 0.98rem;
      margin-bottom: 12px;
      margin-left: 0px;
      padding: 14px 8vw;
    }
    
    .hero-copy-btn, .hero-like-btn, .hero-dislike-btn {
      font-size: 1rem;
      padding: 2px 4px;
    }
    
    .hero-feedback-thanks {
      font-size: 0.93rem;
      margin-left: 5px;
    }
    
    .hero-empty-chat-headline {
      font-size: 1.5rem;
      margin-top: 7vh;
      margin-bottom: 28px;
    }
    
    .hero-bot-tooltip {
      max-width: 250px;
      font-size: 0.9rem;
      padding: 6px 12px;
      width: 250%;
    }
    
    .hero-input-card {
      padding: 14px 20px;
    }

    .hero-input-card-messages {
        padding: 14px 20px;
    }
    
    .hero-action-buttons {
      width: 90%;
      gap: 12px;
    }
    
    .hero-action-btn {
      padding: 12px 16px;
      font-size: 0.85rem;
    }
  }
  
  /* Large Mobile (600px - 767px) */
  @media (max-width: 767px) and (min-width: 600px) {
    .hero-message, .hero-message.user, .hero-message.ai {
      padding: 12px 4vw;
      font-size: 0.98rem;
    }
    
    .hero-message-actions-row {
      padding: 12px 4vw;
      font-size: 0.95rem;
    }
    
    .hero-input-area {
      max-width: 92vw;
      padding: 0 2px;
    }
    
    .hero-chat-input {
      font-size: 0.98rem;
      padding: 12px 10px;
    }
    
    .hero-send-btn {
      font-size: 0.98rem;
      padding: 0 12px;
    }
    
    .hero-send-btn-messages {
      font-size: 0.98rem;
      padding: 0 12px;
      height: 44px;
    }
    
    .hero-messages {
      padding: 6px 0 16px 0;
    }
    
    .hero-bot-picker-btn {
      padding: 5px 10px;
      font-size: 0.92rem;
    }
    
    .hero-bot-picker-row {
      gap: 8px;
      flex-wrap: wrap;
    }
    
    .hero-message-actions-row {
      gap: 5px;
      font-size: 0.95rem;
      padding: 12px 4vw;
    }
    
    .hero-copy-btn, .hero-like-btn, .hero-dislike-btn {
      font-size: 0.97rem;
      padding: 2px 3px;
    }
    
    .hero-empty-chat-headline {
      font-size: 1.3rem;
      margin-top: 6vh;
    }
    
    .hero-input-card {
      padding: 12px 16px;
    }

    .hero-input-card-messages {
        padding: 12px 16px;
    }
    
    .hero-action-buttons {
      width: 95%;
      gap: 10px;
    }
    
    .hero-action-btn {
      padding: 11px 14px;
      font-size: 0.82rem;
    }
  }
  
  /* Mobile (480px - 599px) */
  @media (max-width: 599px) and (min-width: 480px) {
    .hero-message, .hero-message.user, .hero-message.ai {
      padding: 12px 3vw;
      font-size: 0.97rem;
    }
    
    .hero-message-actions-row {
      padding: 12px 3vw;
      font-size: 0.93rem;
    }
    
    .hero-input-area {
      max-width: 90vw;
      margin: 0 auto 0 auto;
      padding: 0 0.5px;
    }
    
    .hero-chat-input {
      font-size: 0.97rem;
      padding: 10px 8px;
      margin-right: 6px;
    }
    
    .hero-send-btn {
      font-size: 0.97rem;
      padding: 0 10px;
    }
    
    .hero-send-btn-messages {
      font-size: 0.97rem;
      padding: 0 10px;
      height: 42px;
    }
    
    .hero-messages {
      padding: 6px 0 18px 0;
      align-items: center;
      width: 99%;
    }
    
    .hero-bot-picker-btn {
      padding: 4px 8px;
      font-size: 0.91rem;
      margin-right: 2px;
      min-width: 0;
      height: auto;
    }
    
    .hero-bot-picker-row {
      padding: 10px 8px 0 8px;
      gap: 6px;
      flex-wrap: wrap;
    }
    
    .hero-message-actions-row {
      gap: 4px;
      font-size: 0.93rem;
      margin-bottom: 8px;
      margin-left: auto;
      margin-right: auto;
      padding: 0!important;
      max-width: 90vw;
    }
    
    .hero-copy-btn, .hero-like-btn, .hero-dislike-btn {
      font-size: 0.95rem;
      padding: 1px 2px;
    }
    
    .hero-feedback-thanks {
      font-size: 0.9rem;
      margin-left: 3px;
    }
    
    .hero-empty-chat-headline {
      font-size: 1.15rem;
      margin-top: 4vh;
      margin-bottom: 18px;
    }
    
    .hero-bot-tooltip {
      max-width: 250px;
      font-size: 0.75rem;
      padding: 5px 10px;
      top: 110%;
      width: 150%;
    }
    
    .hero-input-card {
      padding: 10px 12px;
    }

    .hero-input-card-messages {
        padding: 10px 12px;
    }
    
    .hero-action-buttons {
      width: 98%;
      gap: 8px;
    }
    
    .hero-action-btn {
      padding: 10px 12px;
      font-size: 0.8rem;
    }
  }
  
  /* Small Mobile (320px - 479px) */
  @media (max-width: 479px) and (min-width: 320px) {
    .hero-message, .hero-message.user, .hero-message.ai {
      padding: 10px 2vw;
      font-size: 0.95rem;
    }
    
    .hero-message-actions-row {
      padding: 10px 2vw;
      font-size: 0.9rem;
    }
    
    .hero-input-area {
      max-width: 88vw;
      padding: 0 1px;
    }
    
    .hero-chat-input {
      font-size: 0.95rem;
      padding: 8px 6px;
      margin-right: 4px;
    }
    
    .hero-send-btn {
      font-size: 0.95rem;
      padding: 0 8px;
    }
    
    .hero-send-btn-messages {
      font-size: 0.95rem;
      padding: 0 8px;
      height: 40px;
    }
    
    .hero-messages {
      padding: 4px 0 14px 0;
    }
    
    .hero-bot-picker-btn {
      padding: 3px 6px;
      font-size: 0.88rem;
      margin-right: 1px;
    }
    
    .hero-bot-picker-row {
      padding: 8px 6px 0 6px;
      gap: 4px;
    }
    
    .hero-message-actions-row {
      gap: 3px;
      font-size: 0.9rem;
      padding: 10px 2vw;
    }
    
    .hero-copy-btn, .hero-like-btn, .hero-dislike-btn {
      font-size: 0.92rem;
      padding: 1px 1px;
    }
    
    .hero-empty-chat-headline {
      font-size: 1rem;
      margin-top: 3vh;
      margin-bottom: 16px;
    }
    
    .hero-input-card {
      padding: 8px 10px;
    }

    .hero-input-card-messages {
      padding: 8px 10px;
    }
    
    .hero-action-buttons {
      width: 100%;
      gap: 6px;
    }
    
    .hero-action-btn {
      padding: 8px 10px;
      font-size: 0.78rem;
      min-height: 60px;
    }
    
    .hero-action-btn span {
      font-size: 0.72rem;
    }
    
    .hero-example-item {
      padding: 6px 10px;
      font-size: 0.72rem;
    }
  }
  
  /* Extra Small Mobile (below 320px) */
  @media (max-width: 319px) {
    .hero-message, .hero-message.user, .hero-message.ai {
      padding: 8px 1vw;
      font-size: 0.9rem;
    }
    
    .hero-message-actions-row {
      padding: 8px 1vw;
      font-size: 0.85rem;
    }
    
    .hero-input-area {
      max-width: 85vw;
    }
    
    .hero-chat-input {
      font-size: 0.9rem;
      padding: 6px 4px;
    }
    
    .hero-send-btn {
      font-size: 0.9rem;
    }
    
    .hero-send-btn-messages {
      font-size: 0.9rem;
      padding: 0 6px;
      height: 38px;
    }
    
    .hero-bot-picker-btn {
      padding: 2px 4px;
      font-size: 0.85rem;
    }
    
    .hero-empty-chat-headline {
      font-size: 0.9rem;
      margin-top: 2vh;
    }
    
    .hero-input-card {
      padding: 6px 8px;
    }

    .hero-input-card-messages {
        padding: 6px 8px;
      }
    
    .hero-action-btn {
      padding: 6px 8px;
      font-size: 0.75rem;
      min-height: 50px;
    }
    
    .hero-action-btn span {
      font-size: 0.7rem;
    }
    
    .hero-example-item {
      padding: 4px 8px;
      font-size: 0.7rem;
    }
  }
  
  /* Landscape orientation adjustments for mobile */
  @media (max-width: 900px) and (orientation: landscape) {
    .hero-empty-center-wrapper {
      min-height: 70vh;
      padding-top: 10vh;
    }
    
    .hero-empty-chat-headline {
      font-size: 1.2rem;
      margin-top: 2vh;
      margin-bottom: 12px;
    }
    
    .hero-bot-picker-row {
      margin-top: 16px;
      margin-bottom: 12px;
    }
    
    .hero-messages {
      padding: 4px 0 12px 0;
    }
    
    .hero-input-area.with-messages {
      margin-top: 8px;
      margin-bottom: 8px;
    }
  }
  
  /* High DPI displays */
  @media (min-resolution: 192dpi) {
    .hero-chat-input, .hero-send-btn, .hero-bot-picker-btn, .hero-action-btn {
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }
  
  /* Reduced motion for accessibility */
  @media (prefers-reduced-motion: reduce) {
    .hero-chat-area,
    .hero-message,
    .hero-input-area,
    .hero-chat-input,
    .hero-send-btn,
    .hero-bot-picker-btn,
    .hero-action-btn,
    .hero-typing-indicator .hero-dot,
    .hero-expanded-examples {
      transition: none;
      animation: none;
    }
    
    .hero-typing-indicator .hero-dot {
      animation: none;
    }
  }
  
  /* Markdown formatting styles */
  .hero-markdown-content {
    width: 100%;
  }
  
  .hero-markdown-paragraph {
    margin-bottom: 0px;
    line-height: 1.5;
    font-size: 16px;
  }
  
  .hero-markdown-heading {
    margin-top: 18px;
    margin-bottom: 16px;
    font-weight: 600;
    line-height: 1.25;
  }
  
  .hero-markdown-heading:first-child {
    margin-top: 0;
  }
  
  h1.hero-markdown-heading {
    font-size: 19px;
  }
  
  h2.hero-markdown-heading {
    font-size: 18px;
  }
  
  h3.hero-markdown-heading {
    font-size: 17px;
  }
  
  .hero-markdown-list, .hero-markdown-ordered-list {
    margin-bottom: 16px;
    padding-left: 2em;
    font-size: 16px;
  }
  
  .hero-markdown-list-item {
    margin-bottom: 6px;
  }
  
  .hero-markdown-divider {
    height: 0.25em;
    margin: 24px 0;
    background-color: rgba(0, 0, 0, 0.1);
    border: 0;
  }
  
  .hero-markdown-blockquote {
    padding: 0 1em;
    margin-left: 0;
    margin-right: 0;
    color: #6a737d;
    border-left: 0.25em solid #dfe2e5;
  }
  
  .hero-markdown-code-block {
    padding: 16px;
    overflow: auto;
    font-size: 85%;
    line-height: 1.45;
    background-color: #f6f8fa;
    border-radius: 3px;
    margin-bottom: 16px;
    white-space: pre-wrap;
  }
  
  /* Dark theme adjustments */
  .hero-message.ai .hero-markdown-code-block {
    background-color: #2d333b;
    color: #e6edf3;
  }
  
  .hero-message.ai .hero-markdown-blockquote {
    border-left-color: #444c56;
    color: #adbac7;
  }
  
  .hero-message.ai .hero-markdown-divider {
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  /* Add styles for message actions alignment */
  .hero-message.user + .hero-message-actions-row {
    justify-content: end;
  }
  
  .hero-ai-message-wrapper + .hero-message-actions-row {
    justify-content: center;
    width: 55%;
    margin-left: 0px; /* Align with AI message content (avatar width + gap) */
  }
  
  .hero-input-card {
    background-color: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(4px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 24px;
    box-shadow: 0 2px 16px rgba(23,32,43,0.06);
    padding: 12px 32px 12px 32px;
    width: 60%;
    max-width: 1300px;
    margin: 0 auto 0 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    position: relative;
    z-index: 2;
  }

  .hero-input-card-messages {
    background: rgba(249, 249, 249, 1);
    backdrop-filter: blur(4px);
    border: 1px solid rgba(213, 213, 213, 1);
    border-radius: 24px;
    box-shadow: 0 2px 16px rgba(23,32,43,0.06);
    padding: 12px 32px 12px 32px;
    width: 60%;
    max-width: 1300px;
    margin: 0 auto 0 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    position: relative;
    z-index: 2;
  }
  
  /* Responsive width adjustments for input card */
  @media (max-width: 1199px) {
    .hero-input-card {
      width: 80%;
    }
    .hero-input-card-messages {
        width: 80%;
      }
  }
  
  @media (max-width: 899px) {
    .hero-input-card {
      width: 90%;
    }
    .hero-input-card-messages {
        width: 90%;
      }
  }
  
  @media (max-width: 767px) {
    .hero-input-card {
      width: 95%;
    }
    .hero-input-card-messages {
        width: 95%;
      }
  }
  
  @media (max-width: 599px) {
    .hero-input-card {
      width: 98%;
    }
    .hero-input-card-messages {
        width: 98%;
      }
  }
  
  @media (max-width: 479px) {
    .hero-input-card {
      width: 99%;
    }
    .hero-input-card-messages {
        width: 99%;
      }
  }
  
  .hero-tab-buttons {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
    margin-bottom: 18px;
    margin-top: 18px;
  }
  
  .hero-tab-btn {
    background-color: transparent;
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    border-radius: 10px;
    padding: 8px 16px;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.18s, color 0.18s, box-shadow 0.18s;
  }
  
  .hero-tab-btn.active {
    background: #fff;
    color: #787878;
    font-weight: 500;
    box-shadow: 0 4px 16px rgba(47,128,237,0.10);
  }
  
  .hero-tab-btn:hover {
    font-weight: 500;
    box-shadow: 0 4px 16px rgba(47,128,237,0.30);
  }

  .hero-tab-btn-messages {
    background: rgba(255, 255, 255, 1);
    color: rgba(135, 135, 135, 1);
    border: none;
    border-radius: 10px;
    padding: 8px 16px;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.18s, color 0.18s, box-shadow 0.18s;
  }

  .hero-tab-btn-messages.active {
    background: rgba(38, 84, 255, 0.1);
    color: rgba(19, 40, 118, 1);
    font-weight: 500;
    box-shadow: 0 4px 16px rgba(47,128,237,0.10);
  }

  .hero-tab-btn-messages:hover {
    font-weight: 500;
    box-shadow: 0 4px 16px rgba(47,128,237,0.30);
  }
  
  .hero-input-row {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
  }
  
  .hero-input-card .hero-chat-input {
    flex: 1 1;
    padding: 18px 0px;
    border-radius: 18px;
    border: none !important;
    background: none;
    font-size: 16px;
    font-weight: 700;
    font-family: 'Gilroy', sans-serif;
    outline: none;
    transition: border 0.2s, box-shadow 0.2s;
    box-shadow: none !important;
    min-width: 0;
    caret-color: #fff;
    color: #fff;
  }
  
  .hero-input-card .hero-chat-input::placeholder {
    font-weight: 400;
    font-size: 16px;
    padding: 0;
    color: #fff;
  }
  
  .hero-input-card .hero-chat-input:focus {
    background: none;
  }

  .hero-input-card-messages .hero-chat-input {
    flex: 1 1;
    padding: 18px 0px;
    border-radius: 18px;
    border: none !important;
    background: rgba(249, 249, 249, 1);
    font-size: 16px;
    font-weight: 700;
    font-family: 'Gilroy', sans-serif;
    outline: none;
    transition: border 0.2s, box-shadow 0.2s;
    box-shadow: none !important;
    min-width: 0;
    caret-color: rgba(174, 174, 174, 1);
    color: #747576;
  }
  
  .hero-input-card-messages .hero-chat-input::placeholder {
    font-weight: 400;
    font-size: 16px;
    padding: 0;
  }
  
  .hero-input-card-messages .hero-chat-input:focus {
    background: rgba(249, 249, 249, 1);
  }
  
  .hero-send-btn {
    background: #fff;
    color:#000;
    border: none;
    border-radius: 23px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s, color 0.2s, box-shadow 0.2s;
    box-shadow: 0 2px 8px rgba(23,32,43,0.06);
  }
  
  .hero-send-btn:disabled {
    cursor: not-allowed;
  }
  
  .hero-send-btn:hover:not(:disabled), .hero-send-btn:focus:not(:disabled) {
    background: #fff;
    color: #000;
  }

  .hero-send-btn-messages {
    background: rgba(38, 84, 255, 0.1);
    color:rgba(19, 39, 117, 1);
    border: none;
    border-radius: 23px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s, color 0.2s, box-shadow 0.2s;
    padding: 0 16px;
    height: 48px;
  }
  
  .hero-send-btn-messages:disabled {
    cursor: not-allowed;
  }
  
  .hero-send-btn-messages:hover:not(:disabled), .hero-send-btn-messages:focus:not(:disabled) {
    box-shadow: 0 2px 8px rgba(23,32,43,0.06);
  }
  
  /* Medium Tablet and below (700px and below) - Enhanced responsive design */
  @media (max-width: 700px) {
    .hero-input-card {
      padding: 18px 8px 14px 8px;
    }

    .hero-input-card-messages {
        padding: 18px 8px 14px 8px;
      }
    
    .hero-tab-buttons {
      gap: 6px;
      margin-bottom: 10px;
    }
    
    .hero-input-card .hero-chat-input {
      padding: 14px 10px;
      font-size: 1rem;
    }

    .hero-input-card-messages .hero-chat-input {
        padding: 14px 10px;
        font-size: 1rem;
      }
    
    .hero-send-btn {
      font-size: 1rem;
    }
    
    .hero-send-btn-messages {
      font-size: 1rem;
      padding: 0 14px;
      height: 44px;
    }
    
    .hero-action-buttons {
      width: 95%;
      gap: 10px;
      margin-top: 18px;
      margin-bottom: 10px;
    }
    
    .hero-action-btn {
      padding: 12px 14px;
      font-size: 0.83rem;
      min-height: 65px;
    }
    
    .hero-action-btn span {
      font-size: 0.78rem;
    }
    
    .hero-example-item {
      padding: 9px 14px;
      font-size: 0.78rem;
    }
    
    .hero-message, .hero-message.user, .hero-message.ai {
      padding: 13px 6vw;
      font-size: 0.99rem;
    }
    
    .hero-message-actions-row {
      padding: 13px 6vw;
    }
    
    .hero-input-area {
      max-width: 92vw;
    }
    
    .hero-chat-input {
      font-size: 0.99rem;
      padding: 12px 10px;
    }
    
    .hero-bot-picker-btn {
      padding: 6px 11px;
      font-size: 0.93rem;
    }
    
    .hero-empty-chat-headline {
      font-size: 1.4rem;
      margin-top: 6vh;
    }
  }
  
  .hero-action-buttons {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 16px;
    margin-top: 24px;
    margin-bottom: 16px;
    width: 78%;
    max-width: 1400px;
    margin-left: auto;
    margin-right: auto;
    overflow: visible;
    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 1;
    transform: translateY(0);
  }
  
  .hero-action-buttons.fading {
    opacity: 0;
    transform: translateY(-10px);
  }
  
  .hero-action-buttons:not(.expanded) {
    align-content:baseline; 
  }
  
  .hero-action-btn {
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(4px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    padding: 16px 20px;
    font-size: 0.9rem;
    font-weight: 500;
    color: #AEAEAE;
    cursor: pointer;
    transition: background 0.3s ease, border 0.3s ease, box-shadow 0.3s ease, scale 0.3s ease, border-radius 0.3s ease;
    outline: none;
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1 1;
    min-height: 70px;
    width: 100%;
    text-align: left;
    line-height: 1.4;
  }
  
  .hero-action-btn.expanded {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  }
  
  .hero-action-btn:hover {
    box-shadow: 0 8px 32px rgba(23,32,43,0.08);
  }
  
  .hero-action-btn span {
    flex: 1 1;
    font-size: 0.85rem;
    line-height: 1.3;
    color: #fff;
  }
  
  .hero-action-btn svg {
    color: #132876;
  }
  
  .hero-action-btn-container {
    position: relative;
    flex: 1 1;
    max-width: 78%;
    overflow: visible;
    display: flex;
    flex-direction: column;
  }
  
  .hero-dropdown-arrow {
    transition: transform 0.3s ease;
    color: #AEAEAE;
    flex-shrink: 0;
  }
  
  .hero-dropdown-arrow.rotated {
    transform: rotate(180deg);
  }
  
  .hero-expanded-examples {
    width: 100%;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(4px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-top: none;
    border-radius: 0 0 12px 12px;
    overflow: hidden;
    margin-top: 0;
    position: static;
    box-shadow: 0 4px 16px rgba(23,32,43,0.08);
    animation: expandDown 0.3s ease-out;
    transform-origin: top;
  }
  
  .hero-example-item {
    width: 100%;
    padding: 12px 20px;
    background: none;
    border: none;
    text-align: left;
    font-size: 0.9rem;
    color: #AEAEAE;
    cursor: pointer;
    transition: background 0.3s ease, color 0.3s ease, transform 0.2s ease;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    line-height: 1.4;
  }
  
  .hero-example-item:last-child {
    border-bottom: none;
  }
  
  .hero-example-item:hover {
    transform: translateX(4px);
  }
  
  .hero-example-item:focus {
    color: #132775;
    outline: none;
    transform: translateX(4px);
  }
  
  .hero-example-item:active {
    color: #132775;
    transform: translateX(4px) scale(0.98);
  }
  
  /* Tablet and below (900px and below) - Action buttons responsive design */
  @media (max-width: 900px) {
    .hero-action-buttons {
      gap: 12px;
      margin-top: 20px;
      margin-bottom: 12px;
      padding: 0 16px;
      width: 90%;
    }
    
    .hero-action-btn {
      padding: 12px 16px;
      font-size: 0.85rem;
      max-width: 180px;
      min-height: 68px;
    }
    
    .hero-action-btn span {
      font-size: 0.8rem;
    }
    
    .hero-expanded-examples {
      margin-top: 0;
    }
    
    .hero-example-item {
      padding: 10px 16px;
      font-size: 0.8rem;
    }
    
    .hero-action-btn-container {
      max-width: 90%;
    }
  }
  
  /* Mobile and below (600px and below) - Enhanced responsive design */
  @media (max-width: 600px) {
    .hero-action-buttons {
      flex-direction: column;
      gap: 8px;
      margin-top: 16px;
      margin-bottom: 8px;
      padding: 0 8px;
    }
    
    .hero-action-btn {
      padding: 10px 14px;
      font-size: 0.8rem;
      max-width: 100%;
      width: 100%;
    }
    
    .hero-action-btn span {
      font-size: 0.75rem;
    }
    
    .hero-expanded-examples {
      margin-top: 0;
    }
    
    .hero-example-item {
      padding: 8px 14px;
      font-size: 0.75rem;
    }
    
    /* Additional mobile optimizations */
    .hero-input-card {
      padding: 12px 16px;
    }
    
    .hero-input-card-messages {
        padding: 12px 16px;
      }
    
    .hero-tab-buttons {
      gap: 4px;
      margin-bottom: 8px;
    }
    
    .hero-tab-btn {
      padding: 6px 12px;
      font-size: 0.9rem;
    }

    .hero-tab-btn-messages {
        padding: 6px 12px;
        font-size: 0.9rem;
      }
    
    .hero-input-card .hero-chat-input {
      padding: 12px 8px;
      font-size: 0.95rem;
    }

    .hero-input-card-messages .hero-chat-input {
        padding: 12px 8px;
        font-size: 0.95rem;
      }
    
    .hero-send-btn {
      font-size: 0.95rem;
    }
    
    .hero-send-btn-messages {
      font-size: 0.95rem;
      padding: 0 12px;
      height: 42px;
    }
    
    .hero-message, .hero-message.user, .hero-message.ai {
      padding: 12px 12px;
      font-size: 0.96rem;
    }
    
    .hero-message-actions-row {
      padding: 12px 3vw;
    }
    
    .hero-input-area {
      max-width: 92vw;
      padding: 0 2px;
    }
    
    .hero-chat-input {
      font-size: 0.96rem;
      padding: 10px 8px;
    }
    
    .hero-messages {
      padding: 6px 0 16px 0;
    }
    
    .hero-bot-picker-btn {
      padding: 5px 10px;
      font-size: 0.9rem;
    }
    
    .hero-message-actions-row {
      gap: 4px;
      font-size: 0.94rem;
      padding: 12px 3vw;
    }
    
    .hero-copy-btn, .hero-like-btn, .hero-dislike-btn {
      font-size: 0.94rem;
      padding: 2px 3px;
    }
    
    .hero-empty-chat-headline {
      font-size: 1.2rem;
      margin-top: 5vh;
    }
  }
  
  /* Touch device optimizations */
  @media (hover: none) and (pointer: coarse) {
    .hero-copy-btn, .hero-like-btn, .hero-dislike-btn {
      min-height: 44px;
      min-width: 44px;
      padding: 8px 12px;
    }
    
    .hero-bot-picker-btn {
      min-height: 44px;
      padding: 8px 16px;
    }
    
    .hero-send-btn {
      min-height: 44px;
      min-width: 44px;
    }
    
    .hero-send-btn-messages {
      min-height: 44px;
      min-width: 44px;
    }
    
    .hero-action-btn {
      min-height: 60px;
    }
    
    .hero-tab-btn {
      min-height: 44px;
      padding: 10px 20px;
    }

    .hero-tab-btn-messages {
        min-height: 44px;
        padding: 10px 20px;
      }
    
    .hero-example-item {
      min-height: 44px;
      padding: 12px 20px;
    }
  }
  
  /* High contrast mode support */
  @media (prefers-contrast: high) {
    .hero-message.user {
      border: 2px solid #17202B;
    }
    
    .hero-chat-input {
      border: 2px solid #17202B;
    }
    
    .hero-send-btn {
      border: 2px solid #132775;
    }
    
    .hero-action-btn {
      border: 1px solid rgba(255, 255, 255, 0.2);
    }
    
    .hero-bot-picker-btn {
      border: 2px solid #2F80ED;
    }
  }
  
  /* Print styles */
  @media print {
    .hero-chat-area {
      background: white !important;
      color: black !important;
    }
    
    .hero-input-area,
    .hero-send-btn,
    .hero-action-buttons,
    .hero-bot-picker-row {
      display: none !important;
    }
    
    .hero-message {
      break-inside: avoid;
      page-break-inside: avoid;
    }
  }
  
  /* Focus visible for better accessibility */
  .hero-copy-btn:focus-visible,
  .hero-like-btn:focus-visible,
  .hero-dislike-btn:focus-visible,
  .hero-send-btn:focus-visible,
  .hero-bot-picker-btn:focus-visible,
  .hero-action-btn:focus-visible,
  .hero-example-item:focus-visible {
    outline: 2px solid #2F80ED;
    outline-offset: 2px;
  }
  
  /* Improved scrolling for mobile */
  @media (max-width: 900px) {
    .hero-messages {
      -webkit-overflow-scrolling: touch;
      scroll-behavior: smooth;
    }
    
    .hero-chat-input {
      -webkit-appearance: none;
      border-radius: 24px;
    }
    
    .hero-send-btn {
      -webkit-tap-highlight-color: transparent;
    }
  }
  
  /* Landscape phone optimizations */
  @media (max-width: 900px) and (orientation: landscape) and (max-height: 500px) {
    .hero-empty-center-wrapper {
      min-height: 60vh;
      padding-top: 5vh;
    }
    
    .hero-empty-chat-headline {
      font-size: 1rem;
      margin-top: 2vh;
      margin-bottom: 8px;
    }
    
    .hero-bot-picker-row {
      margin-top: 8px;
      margin-bottom: 8px;
    }
    
    .hero-messages {
      padding: 2px 0 8px 0;
    }
    
    .hero-input-area.with-messages {
      margin-top: 4px;
      margin-bottom: 4px;
    }
    
    .hero-action-buttons {
      margin-top: 8px;
      margin-bottom: 6px;
    }
    
    .hero-action-btn {
      min-height: 50px;
      padding: 8px 12px;
    }
  }
  
  /* Ultra-wide screen support */
  @media (min-width: 2000px) {
    .hero-message, .hero-message.user, .hero-message.ai {
      max-width: 1300px;
      font-size: 1.3rem;
    }
    
    .hero-input-card {
      width: 60%;
      max-width: 1600px;
    }

    .hero-input-card-messages {
        width: 60%;
        max-width: 1600px;
      }
    
    .hero-action-buttons {
      width: 60%;
      max-width: 1800px;
    }
    
    .hero-empty-chat-headline {
      font-size: 28px;
    }
    
    .hero-bot-picker-btn {
      font-size: 1.1rem;
      padding: 10px 24px;
    }
    
    .hero-chat-input {
      font-size: 1.2rem;
      padding: 24px 0px;
    }
    
    .hero-send-btn {
      font-size: 18px;
    }
    
    .hero-send-btn-messages {
      font-size: 18px;
      padding: 0 20px;
      height: 52px;
    }
  }
  
  .hero-ai-message-row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
  }
  
  .hero-ai-message-wrapper {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 16px;
    justify-content: flex-start;
    width: 60%;
    max-width: 1300px;
    margin-left: auto;
    margin-right: auto;
  }
  
  /* Responsive width adjustments for AI message wrapper */
  @media (max-width: 1199px) {
    .hero-ai-message-wrapper {
      width: 80%;
    }
  }
  
  @media (max-width: 899px) {
    .hero-ai-message-wrapper {
      width: 90%;
    }
  }
  
  @media (max-width: 767px) {
    .hero-ai-message-wrapper {
      width: 95%;
    }
  }
  
  @media (max-width: 599px) {
    .hero-ai-message-wrapper {
      width: 98%;
    }
  }
  
  @media (max-width: 479px) {
    .hero-ai-message-wrapper {
      width: 99%;
    }
  }
  
  .hero-ai-avatar-wrapper{
    width: 45px;
    height: 45px;
    background: #2654FF1A;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 8px;
    flex-shrink: 0;
  }
  
  .hero-ai-avatar{
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
  
  /* Responsive avatar adjustments */
  @media (max-width: 1199px) {
    .hero-ai-avatar-wrapper {
      width: 42px;
      height: 42px;
    }
    
    .hero-ai-avatar {
      width: 18px;
      height: 18px;
    }
  }
  
  @media (max-width: 899px) {
    .hero-ai-avatar-wrapper {
      width: 40px;
      height: 40px;
    }
    
    .hero-ai-avatar {
      width: 17px;
      height: 17px;
    }
  }
  
  @media (max-width: 767px) {
    .hero-ai-avatar-wrapper {
      width: 38px;
      height: 38px;
    }
    
    .hero-ai-avatar {
      width: 16px;
      height: 16px;
    }
  }
  
  @media (max-width: 599px) {
    .hero-ai-avatar-wrapper {
      width: 36px;
      height: 36px;
    }
    
    .hero-ai-avatar {
      width: 15px;
      height: 15px;
    }
  }
  
  @media (max-width: 479px) {
    .hero-ai-avatar-wrapper {
      width: 34px;
      height: 34px;
    }
    
    .hero-ai-avatar {
      width: 14px;
      height: 14px;
    }
  }
  
  @media (max-width: 319px) {
    .hero-ai-avatar-wrapper {
      width: 32px;
      height: 32px;
    }
    
    .hero-ai-avatar {
      width: 13px;
      height: 13px;
    }
  }

  /* Message limit warning styling */
  .hero-message-limit-warning {
    background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
    color: white;
    padding: 12px 16px;
    border-radius: 8px;
    margin-top: 12px;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);
    animation: warning-pulse 2s ease-in-out infinite;
  }

  @keyframes warning-pulse {
    0%, 100% {
      transform: scale(1);
      box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);
    }
    50% {
      transform: scale(1.02);
      box-shadow: 0 6px 16px rgba(255, 107, 107, 0.4);
    }
  }

  .hero-message-limit-warning strong {
    font-weight: 600;
  }

  /* Disabled state styling for buttons when message limit is reached */
  .hero-action-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }

  .hero-tab-btn:disabled,
  .hero-tab-btn-messages:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }

  .hero-chat-input:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background-color: #f5f5f5;
  }

  .hero-send-btn:disabled,
  .hero-send-btn-messages:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }`, "",{"version":3,"sources":["webpack://./src/components/LandingPage/HeroChat.css"],"names":[],"mappings":"AAAA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,iDAAiD;IACjD,mBAAmB;IACnB,qBAAqB,EAAE,YAAY;IACnC,wBAAwB,EAAE,0BAA0B;EACtD;;EAEA,8DAA8D;EAC9D;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,iDAAiD;IACjD,wBAAwB;IACxB,UAAU;EACZ;;EAEA,8CAA8C;EAC9C;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,gBAAgB,EAAE,sCAAsC;IACxD,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,UAAU;IACV,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;;IAEE,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,sCAAsC;IACtC,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,iDAAiD;IACjD,wBAAwB;IACxB,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;IACxB,UAAU;EACZ;;EAEA;IACE,2BAA2B;IAC3B,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,4CAA4C;EAC9C;;EAEA;IACE,yDAA2C;IAC3C,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,iBAAiB;IACjB,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,iDAAiD;IACjD,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA,iFAAiF;EACjF;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;IACA;MACE,UAAU;MACV,4BAA4B;IAC9B;EACF;;AAEF;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,UAAU;EACV,wBAAwB;EACxB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,8CAA8C;EAC9C,UAAU;EACV,wBAAwB;EACxB,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,oBAAoB;AACtB;;EAEE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,iDAAiD;IACjD,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,2DAA2D;IAC3D,yCAAyC;IACzC,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,cAAc;IACd,2CAA2C;EAC7C;;EAEA;IACE,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,4CAA4C;EAC9C;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX,yCAAyC;IACzC,2CAA2C;IAC3C,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;EACpB;;AAEF;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;AAChB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,cAAc;AAClB;;EAEE,qDAAqD;EACrD;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;MACV,eAAe;IACjB;EACF;;EAEA;IACE;MACE,UAAU;MACV,eAAe;IACjB;EACF;;EAEA;IACE;MACE,UAAU;MACV,eAAe;IACjB;EACF;;EAEA;IACE;MACE,UAAU;MACV,eAAe;IACjB;EACF;;EAEA;IACE;MACE,WAAW;MACX,cAAc;IAChB;EACF;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA,+CAA+C;EAC/C;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;;EAEA;IACE;MACE,wBAAwB;MACxB,YAAY;IACd;IACA;MACE,2BAA2B;MAC3B,UAAU;IACZ;EACF;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,cAAc;EAChB;;EAEA,yDAAyD;EACzD;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;;IAEE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,wCAAwC;IACxC,kBAAkB;EACpB;;EAEA;IACE,KAAK,UAAU,EAAE;EACnB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,yCAAyC;IACzC,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX,UAAU;IACV,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE;MACE,UAAU;MACV,4CAA4C;IAC9C;IACA;MACE,UAAU;MACV,yCAAyC;IAC3C;IACA;MACE,UAAU;MACV,yCAAyC;IAC3C;IACA;MACE,UAAU;MACV,2CAA2C;IAC7C;EACF;;EAEA;IACE;MACE,UAAU;MACV,oBAAoB;MACpB,aAAa;IACf;IACA;MACE,UAAU;MACV,oBAAoB;MACpB,iBAAiB;IACnB;EACF;;EAEA,qCAAqC;EACrC;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,UAAU;MACV,iBAAiB;IACnB;;IAEA;QACI,UAAU;QACV,iBAAiB;MACnB;;IAEF;MACE,UAAU;MACV,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,eAAe;MACf,YAAY;IACd;EACF;;EAEA,8BAA8B;EAC9B;;IAEE;MACE,UAAU;IACZ;;IAEA;QACI,UAAU;IACd;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,eAAe;MACf,eAAe;MACf,YAAY;IACd;EACF;;EAEA,kCAAkC;EAClC;IACE;MACE,kBAAkB;MAClB,kBAAkB;IACpB;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,UAAU;MACV,kBAAkB;IACpB;;IAEA;QACI,UAAU;QACV,kBAAkB;IACtB;;IAEA;MACE,UAAU;MACV,SAAS;IACX;;IAEA;MACE,kBAAkB;MAClB,kBAAkB;IACpB;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA,2BAA2B;EAC3B;IACE;MACE,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,qBAAqB;MACrB,cAAc;IAChB;;IAEA;MACE,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,eAAe;MACf,YAAY;IACd;;IAEA;MACE,eAAe;MACf,eAAe;MACf,YAAY;IACd;;IAEA;MACE,qBAAqB;MACrB,QAAQ;MACR,cAAc;MACd,mBAAmB;MACnB,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;MACjB,kBAAkB;MAClB,iBAAiB;MACjB,YAAY;MACZ,YAAY;IACd;;IAEA;MACE,QAAQ;MACR,kBAAkB;MAClB,mBAAmB;MACnB,gBAAgB;MAChB,iBAAiB;IACnB;;IAEA;MACE,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;MACjB,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;MAChB,iBAAiB;MACjB,iBAAiB;MACjB,WAAW;IACb;;IAEA;MACE,kBAAkB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;MACE,UAAU;MACV,SAAS;IACX;;IAEA;MACE,kBAAkB;MAClB,kBAAkB;IACpB;EACF;;EAEA,iCAAiC;EACjC;IACE;MACE,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,cAAc;IAChB;;IAEA;MACE,kBAAkB;MAClB,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,kBAAkB;MAClB,eAAe;MACf,YAAY;IACd;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,QAAQ;MACR,eAAe;IACjB;;IAEA;MACE,QAAQ;MACR,kBAAkB;MAClB,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;MACjB,eAAe;IACjB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;MACE,UAAU;MACV,SAAS;IACX;;IAEA;MACE,kBAAkB;MAClB,kBAAkB;IACpB;EACF;;EAEA,2BAA2B;EAC3B;IACE;MACE,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,qBAAqB;MACrB,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;MAClB,iBAAiB;MACjB,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,kBAAkB;MAClB,eAAe;MACf,YAAY;IACd;;IAEA;MACE,qBAAqB;MACrB,mBAAmB;MACnB,UAAU;IACZ;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,iBAAiB;MACjB,YAAY;MACZ,YAAY;IACd;;IAEA;MACE,uBAAuB;MACvB,QAAQ;MACR,eAAe;IACjB;;IAEA;MACE,QAAQ;MACR,kBAAkB;MAClB,kBAAkB;MAClB,iBAAiB;MACjB,kBAAkB;MAClB,oBAAoB;MACpB,eAAe;IACjB;;IAEA;MACE,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;MAClB,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,iBAAiB;MACjB,SAAS;MACT,WAAW;IACb;;IAEA;MACE,kBAAkB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;MACE,UAAU;MACV,QAAQ;IACV;;IAEA;MACE,kBAAkB;MAClB,iBAAiB;IACnB;EACF;;EAEA,iCAAiC;EACjC;IACE;MACE,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;MACjB,iBAAiB;IACnB;;IAEA;MACE,eAAe;MACf,cAAc;IAChB;;IAEA;MACE,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,cAAc;IAChB;;IAEA;MACE,kBAAkB;MAClB,cAAc;MACd,YAAY;IACd;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,iBAAiB;IACnB;;IAEA;MACE,sBAAsB;MACtB,QAAQ;IACV;;IAEA;MACE,QAAQ;MACR,iBAAiB;MACjB,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,eAAe;MACf,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,WAAW;MACX,QAAQ;IACV;;IAEA;MACE,iBAAiB;MACjB,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;MACjB,kBAAkB;IACpB;EACF;;EAEA,qCAAqC;EACrC;IACE;MACE,gBAAgB;MAChB,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;MACjB,cAAc;MACd,YAAY;IACd;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;MACjB,eAAe;IACjB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;QACI,gBAAgB;MAClB;;IAEF;MACE,gBAAgB;MAChB,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;MAChB,iBAAiB;IACnB;EACF;;EAEA,iDAAiD;EACjD;IACE;MACE,gBAAgB;MAChB,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;MACjB,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,eAAe;MACf,kBAAkB;IACpB;EACF;;EAEA,sBAAsB;EACtB;IACE;MACE,mCAAmC;MACnC,kCAAkC;IACpC;EACF;;EAEA,qCAAqC;EACrC;IACE;;;;;;;;;MASE,gBAAgB;MAChB,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA,+BAA+B;EAC/B;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,oCAAoC;IACpC,SAAS;EACX;;EAEA;IACE,cAAc;IACd,cAAc;IACd,eAAe;IACf,cAAc;IACd,iCAAiC;EACnC;;EAEA;IACE,aAAa;IACb,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA,2BAA2B;EAC3B;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,cAAc;EAChB;;EAEA;IACE,0CAA0C;EAC5C;;EAEA,6CAA6C;EAC7C;IACE,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB,UAAU;IACV,gBAAgB,EAAE,uDAAuD;EAC3E;;EAEA;IACE,0CAA0C;IAC1C,0BAA0B;IAC1B,0CAA0C;IAC1C,mBAAmB;IACnB,0CAA0C;IAC1C,4BAA4B;IAC5B,UAAU;IACV,iBAAiB;IACjB,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,kCAAkC;IAClC,0BAA0B;IAC1B,wCAAwC;IACxC,mBAAmB;IACnB,0CAA0C;IAC1C,4BAA4B;IAC5B,UAAU;IACV,iBAAiB;IACjB,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;EACZ;;EAEA,gDAAgD;EAChD;IACE;MACE,UAAU;IACZ;IACA;QACI,UAAU;MACZ;EACJ;;EAEA;IACE;MACE,UAAU;IACZ;IACA;QACI,UAAU;MACZ;EACJ;;EAEA;IACE;MACE,UAAU;IACZ;IACA;QACI,UAAU;MACZ;EACJ;;EAEA;IACE;MACE,UAAU;IACZ;IACA;QACI,UAAU;MACZ;EACJ;;EAEA;IACE;MACE,UAAU;IACZ;IACA;QACI,UAAU;MACZ;EACJ;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,WAAW;IACX,qDAAqD;IACrD,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,2DAA2D;EAC7D;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,4CAA4C;EAC9C;;EAEA;IACE,gBAAgB;IAChB,4CAA4C;EAC9C;;EAEA;IACE,kCAAkC;IAClC,6BAA6B;IAC7B,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,2DAA2D;EAC7D;;EAEA;IACE,kCAAkC;IAClC,2BAA2B;IAC3B,gBAAgB;IAChB,4CAA4C;EAC9C;;EAEA;IACE,gBAAgB;IAChB,4CAA4C;EAC9C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,SAAO;IACP,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,aAAa;IACb,wCAAwC;IACxC,2BAA2B;IAC3B,YAAY;IACZ,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,aAAa;IACb,wCAAwC;IACxC,2BAA2B;IAC3B,YAAY;IACZ,mCAAmC;IACnC,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,wDAAwD;IACxD,yCAAyC;EAC3C;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kCAAkC;IAClC,0BAA0B;IAC1B,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,wDAAwD;IACxD,eAAe;IACf,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yCAAyC;EAC3C;;EAEA,2EAA2E;EAC3E;IACE;MACE,0BAA0B;IAC5B;;IAEA;QACI,0BAA0B;MAC5B;;IAEF;MACE,QAAQ;MACR,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;MAClB,eAAe;IACjB;;IAEA;QACI,kBAAkB;QAClB,eAAe;MACjB;;IAEF;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,eAAe;MACf,YAAY;IACd;;IAEA;MACE,UAAU;MACV,SAAS;MACT,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;MAClB,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,kBAAkB;MAClB,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;MACjB,eAAe;IACjB;EACF;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,iDAAiD;IACjD,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oCAAoC;IACpC,0BAA0B;IAC1B,0CAA0C;IAC1C,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kHAAkH;IAClH,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;IACP,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;IAC7B,iDAAiD;EACnD;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,SAAO;IACP,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,+BAA+B;IAC/B,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,oCAAoC;IACpC,0BAA0B;IAC1B,0CAA0C;IAC1C,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,0CAA0C;IAC1C,mCAAmC;IACnC,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,sEAAsE;IACtE,iDAAiD;IACjD,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,sCAAsC;EACxC;;EAEA,0EAA0E;EAC1E;IACE;MACE,SAAS;MACT,gBAAgB;MAChB,mBAAmB;MACnB,eAAe;MACf,UAAU;IACZ;;IAEA;MACE,kBAAkB;MAClB,kBAAkB;MAClB,gBAAgB;MAChB,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,kBAAkB;MAClB,iBAAiB;IACnB;;IAEA;MACE,cAAc;IAChB;EACF;;EAEA,oEAAoE;EACpE;IACE;MACE,sBAAsB;MACtB,QAAQ;MACR,gBAAgB;MAChB,kBAAkB;MAClB,cAAc;IAChB;;IAEA;MACE,kBAAkB;MAClB,iBAAiB;MACjB,eAAe;MACf,WAAW;IACb;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA,oCAAoC;IACpC;MACE,kBAAkB;IACpB;;IAEA;QACI,kBAAkB;MACpB;;IAEF;MACE,QAAQ;MACR,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;MACjB,iBAAiB;IACnB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;MACnB;;IAEF;MACE,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;MACpB;;IAEF;MACE,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;MAClB,eAAe;MACf,YAAY;IACd;;IAEA;MACE,kBAAkB;MAClB,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;MACf,cAAc;IAChB;;IAEA;MACE,kBAAkB;MAClB,iBAAiB;IACnB;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,iBAAiB;MACjB,iBAAiB;IACnB;;IAEA;MACE,QAAQ;MACR,kBAAkB;MAClB,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;MACjB,eAAe;IACjB;EACF;;EAEA,+BAA+B;EAC/B;IACE;MACE,gBAAgB;MAChB,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;MAChB,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;MAChB,eAAe;IACjB;;IAEA;MACE,gBAAgB;MAChB,eAAe;IACjB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;MACpB;;IAEF;MACE,gBAAgB;MAChB,kBAAkB;IACpB;EACF;;EAEA,+BAA+B;EAC/B;IACE;MACE,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,0CAA0C;IAC5C;;IAEA;MACE,yBAAyB;IAC3B;EACF;;EAEA,iBAAiB;EACjB;IACE;MACE,4BAA4B;MAC5B,uBAAuB;IACzB;;IAEA;;;;MAIE,wBAAwB;IAC1B;;IAEA;MACE,mBAAmB;MACnB,wBAAwB;IAC1B;EACF;;EAEA,2CAA2C;EAC3C;;;;;;;IAOE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA,kCAAkC;EAClC;IACE;MACE,iCAAiC;MACjC,uBAAuB;IACzB;;IAEA;MACE,wBAAwB;MACxB,mBAAmB;IACrB;;IAEA;MACE,wCAAwC;IAC1C;EACF;;EAEA,kCAAkC;EAClC;IACE;MACE,gBAAgB;MAChB,gBAAgB;IAClB;;IAEA;MACE,eAAe;MACf,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;MAChB,iBAAiB;IACnB;EACF;;EAEA,8BAA8B;EAC9B;IACE;MACE,iBAAiB;MACjB,iBAAiB;IACnB;;IAEA;MACE,UAAU;MACV,iBAAiB;IACnB;;IAEA;QACI,UAAU;QACV,iBAAiB;MACnB;;IAEF;MACE,UAAU;MACV,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;MACjB,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,eAAe;MACf,YAAY;IACd;EACF;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,wDAAwD;EACxD;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA,kCAAkC;EAClC;IACE;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA;IACE;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA;IACE;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA;IACE;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA;IACE;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA;IACE;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA,kCAAkC;EAClC;IACE,6DAA6D;IAC7D,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,+CAA+C;IAC/C,gDAAgD;EAClD;;EAEA;IACE;MACE,mBAAmB;MACnB,+CAA+C;IACjD;IACA;MACE,sBAAsB;MACtB,+CAA+C;IACjD;EACF;;EAEA;IACE,gBAAgB;EAClB;;EAEA,qEAAqE;EACrE;IACE,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;;IAEE,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;;IAEE,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;EACtB","sourcesContent":[".hero-chat-area {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    background: #fff;\n    min-width: 0;\n    position: relative;\n    transition: all 0.3s ease-in-out;\n  }\n  \n  .hero-messages {\n    flex: 1;\n    overflow-y: auto;\n    padding: 32px 0 50px 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    position: relative;\n    height: 65vh;\n    max-height: 100%;\n    scroll-behavior: smooth;\n    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n    /* Hide scrollbar */\n    scrollbar-width: none; /* Firefox */\n    -ms-overflow-style: none; /* Internet Explorer 10+ */\n  }\n  \n  /* Hide scrollbar for WebKit browsers (Chrome, Safari, Edge) */\n  .hero-messages::-webkit-scrollbar {\n    display: none;\n  }\n  \n  .hero-messages.with-content {\n    padding: 16px 0 50px 0;\n  }\n  \n  .hero-message {\n    max-width: 1300px;\n    width: 60%;\n    font-size: 1.1rem;\n    line-height: 1.6;\n    word-break: break-word;\n    display: block;\n    box-shadow: none;\n    border: none;\n    padding: 0;\n    background: none;\n    color: #17202B;\n    margin-left: auto;\n    margin-right: auto;\n    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n    transform: translateY(0);\n    opacity: 1;\n  }\n  \n  /* Responsive width adjustments for messages */\n  @media (max-width: 1199px) {\n    .hero-message, .hero-message.user, .hero-message.ai {\n      width: 80%;\n    }\n  }\n  \n  @media (max-width: 899px) {\n    .hero-message, .hero-message.user, .hero-message.ai {\n      width: 90%;\n    }\n  }\n  \n  @media (max-width: 767px) {\n    .hero-message, .hero-message.user, .hero-message.ai {\n      width: 95%;\n    }\n  }\n  \n  @media (max-width: 599px) {\n    .hero-message, .hero-message.user, .hero-message.ai {\n      width: 98%;\n    }\n  }\n  \n  @media (max-width: 479px) {\n    .hero-message, .hero-message.user, .hero-message.ai {\n      width: 99%;\n    }\n  }\n  \n  .hero-message.entering {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  \n  .hero-message.user {\n    border-radius: 15px;\n    padding: 10px 0px;\n    margin-top: 8px;\n    margin-bottom: 4px;\n    padding-top: 14px;\n    padding-bottom: 14px;\n    color: #17202B;\n    display: flex;\n    justify-content: flex-end;\n    margin-left: 0px; /* leave space on left for AI avatar */\n    margin-right: 0;\n  }\n  \n  .hero-user-message-content {\n    text-align: right;\n    font-size: 16px;\n    color: #17202B;\n    border-radius: 15px;\n    max-width: 520px;\n    min-width: 0;\n    align-self: flex-end;\n    width: fit-content;\n    margin-left: auto;\n    padding: 18px 18px;\n    border: 1px solid #D5D5D5;\n  }\n  \n  .hero-message.user .hero-copy-btn {\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 0.18s;\n  }\n  \n  .hero-message.user:hover .hero-copy-btn,\n  .hero-message.user:focus-within .hero-copy-btn {\n    opacity: 1;\n    pointer-events: auto;\n  }\n  \n  .hero-message.ai {\n    background: none;\n    border-radius: 23px;\n    box-shadow: none;\n    padding: 10px 28px;\n    margin-top: 8px;\n    color: #17202B;\n    max-width: 1300px;\n    width: 60%;\n    margin-left: 0;\n    margin-right: 0;\n    text-align: left;\n    background: #fff;\n    color: #222;\n    border-radius: 15px;\n    padding: 18px 18px;\n    min-width: 0;\n    box-shadow: 0 1px 4px rgba(0,0,0,0.04);\n    margin-bottom: 4px;\n    align-self: flex-start;\n    display: block;\n    width: fit-content;\n  }\n  \n  .hero-input-area {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n    background: none;\n    border: none;\n    box-shadow: none;\n    margin: 0 auto 0px auto;\n    max-width: 600px;\n    width: 100%;\n    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n    transform: translateY(0);\n    opacity: 1;\n  }\n  \n  .hero-input-area {\n    margin-top: 0;\n  }\n  \n  .hero-input-area.with-messages {\n    margin-top: 16px;\n    margin-bottom: 16px;\n    transform: translateY(0);\n    opacity: 1;\n  }\n  \n  .hero-input-area.initial-state {\n    transform: translateY(20px);\n    opacity: 0.8;\n  }\n  \n  .hero-chat-input:focus {\n    border: 1.5px solid #2F80ED;\n    background: #fff;\n    box-shadow: 0 4px 16px rgba(47,128,237,0.10);\n  }\n\n  .hero-top-section{\n    background-image: url('/public/bg-top.png');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    min-height: 100vh;\n    width: 100%;\n    position: relative;\n  }\n  .hero-top-section-white{\n    background: #ffffff;\n    min-height: 100vh;\n    width: 100%;\n    position: relative;\n  }\n  \n  .hero-empty-center-wrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    min-height: 100vh;\n    width: 100%;\n    background: none;\n    padding-top: 30vh;\n    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n    opacity: 1;\n    transform: translateY(0);\n  }\n  \n  .hero-empty-center-wrapper.fading {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  \n  /* Add animation for headline text that appears for 1.2 seconds then disappears */\n  @keyframes headline-fade-in-out {\n    0% {\n      opacity: 0;\n      transform: translateY(10px);\n    }\n    10% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n    80% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n    100% {\n      opacity: 0;\n      transform: translateY(-10px);\n    }\n  }\n\n.hero-empty-chat-headline {\n  text-align: center;\n  font-size: 24px;\n  font-weight: 400;\n  color: #fff;\n  margin-bottom: 20px;\n  letter-spacing: -0.5px;\n  line-height: 60px;\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 0.3s ease, transform 0.3s ease;\n}\n\n.hero-new-text-above-headline {\n  text-align: center;\n  font-size: 24px;\n  font-weight: 400;\n  color: #fff;\n  margin-bottom: 2rem;\n  letter-spacing: -0.5px;\n  line-height: 1.2;\n  animation: headline-fade-in-out 5s ease-in-out;\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 0.3s ease, transform 0.3s ease;\n}\n\n.hero-new-text-above-headline.hidden {\n  opacity: 0;\n  transform: translateY(-10px);\n  pointer-events: none;\n}\n  \n  .hero-bot-picker-row {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    padding: 0;\n    margin-top: 32px;\n    margin-bottom: 18px;\n    background: none;\n    border-top: none;\n    border-bottom: none;\n    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n    opacity: 1;\n    transform: translateY(0);\n  }\n  \n  .hero-bot-picker-row.fading {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  \n  .hero-bot-picker-btn {\n    background: #EEECF9;\n    color: #2F80ED;\n    border: none;\n    border-radius: 999px;\n    padding: 8px 20px;\n    font-size: 1rem;\n    font-weight: 500;\n    margin-right: 6px;\n    cursor: pointer;\n    transition: background 0.18s, color 0.18s, box-shadow 0.18s;\n    box-shadow: 0 1px 4px rgba(23,32,43,0.04);\n    outline: none;\n    position: relative;\n  }\n  \n  .hero-bot-picker-btn:last-child {\n    margin-right: 0;\n  }\n  \n  .hero-bot-picker-btn:hover:not(:disabled), .hero-bot-picker-btn:focus:not(:disabled) {\n    background: #2654FF1A;\n    color: #EEECF9;\n    box-shadow: 0 2px 8px rgba(47,128,237,0.08);\n  }\n  \n  .hero-bot-picker-btn.active {\n    background: #2654FF1A;\n    color: #EEECF9;\n    font-weight: bold;\n    box-shadow: 0 4px 16px rgba(47,128,237,0.10);\n  }\n  \n  .hero-bot-picker-btn:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n  \n  .hero-bot-btn-tooltip-wrapper {\n    position: relative;\n    display: inline-block;\n  }\n  \n  .hero-bot-tooltip {\n    visibility: hidden;\n    opacity: 0;\n    position: absolute;\n    left: 50%;\n    top: 120%;\n    transform: translateX(-50%);\n    background: #EEECF9;\n    color: #17202B;\n    padding: 7px 16px;\n    border-radius: 8px;\n    font-size: 0.98rem;\n    font-weight: 500;\n    white-space: nowrap;\n    pointer-events: none;\n    z-index: 10;\n    box-shadow: 0 2px 8px rgba(23,32,43,0.10);\n    transition: opacity 0.18s, visibility 0.18s;\n    max-width: 250px;\n    width: 250%;\n    word-wrap: break-word;\n    white-space: normal;\n    text-align: center;\n  }\n  \n.hero-disclaimer-text {\n  font-size: 14px;\n  color: #fff;\n  text-align: center;\n  width: 60%;\n  max-width: 1300px;\n  margin: 0 auto;\n}\n\n.hero-disclaimer-text-messages {\n    font-size: 14px;\n    color: rgba(181, 181, 181, 1);\n    text-align: center;\n    width: 60%;\n    max-width: 1300px;\n    margin: 0 auto;\n}\n  \n  /* Responsive width adjustments for disclaimer text */\n  @media (max-width: 1199px) {\n    .hero-disclaimer-text {\n      width: 80%;\n    }\n  }\n  \n  @media (max-width: 899px) {\n    .hero-disclaimer-text {\n      width: 90%;\n      font-size: 13px;\n    }\n  }\n  \n  @media (max-width: 767px) {\n    .hero-disclaimer-text {\n      width: 95%;\n      font-size: 12px;\n    }\n  }\n  \n  @media (max-width: 599px) {\n    .hero-disclaimer-text {\n      width: 98%;\n      font-size: 11px;\n    }\n  }\n  \n  @media (max-width: 479px) {\n    .hero-disclaimer-text {\n      width: 99%;\n      font-size: 10px;\n    }\n  }\n  \n  @media (max-width: 319px) {\n    .hero-disclaimer-text {\n      width: 100%;\n      font-size: 9px;\n    }\n  }\n  \n  .hero-tooltip-title {\n    display: block;\n    font-weight: 600;\n    margin-bottom: 5px;\n  }\n  \n  .hero-tooltip-content {\n    display: block;\n    font-weight: 400;\n  }\n  \n  .hero-bot-btn-tooltip-wrapper:hover .hero-bot-tooltip {\n    visibility: visible;\n    opacity: 1;\n  }\n  \n  .hero-indicator{\n    width: 60%;\n    max-width: 1300px;\n    padding-bottom: 1rem;\n  }\n  \n  /* Responsive width adjustments for indicator */\n  @media (max-width: 1199px) {\n    .hero-indicator {\n      width: 80%;\n    }\n  }\n  \n  @media (max-width: 899px) {\n    .hero-indicator {\n      width: 90%;\n    }\n  }\n  \n  @media (max-width: 767px) {\n    .hero-indicator {\n      width: 95%;\n    }\n  }\n  \n  @media (max-width: 599px) {\n    .hero-indicator {\n      width: 98%;\n    }\n  }\n  \n  @media (max-width: 479px) {\n    .hero-indicator {\n      width: 99%;\n    }\n  }\n  \n  .hero-typing-indicator {\n    display: inline-flex;\n    align-items: flex-end;\n    font-size: 1.1rem;\n    color: #2F80ED;\n    font-weight: 500;\n    letter-spacing: 0.5px;\n  }\n  \n  .hero-typing-indicator .hero-dot {\n    display: inline-block;\n    width: 4px;\n    height: 4px;\n    margin-left: 2px;\n    margin-right: 2px;\n    border-radius: 50%;\n    background: #2F80ED;\n    opacity: 0.7;\n    animation: typing-jump 1.2s infinite both;\n    position: relative;\n    bottom: 5px;\n  }\n  \n  .hero-typing-indicator .hero-dot:nth-child(2) {\n    animation-delay: 0.2s;\n  }\n  .hero-typing-indicator .hero-dot:nth-child(3) {\n    animation-delay: 0.4s;\n  }\n  \n  @keyframes typing-jump {\n    0%, 80%, 100% {\n      transform: translateY(0);\n      opacity: 0.7;\n    }\n    40% {\n      transform: translateY(-8px);\n      opacity: 1;\n    }\n  }\n  \n  .hero-message-actions-row {\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    max-width: 1300px;\n    width: 60%;\n    padding: 0px 0px;\n    margin: 0 auto;\n  }\n  \n  /* Responsive width adjustments for message actions row */\n  @media (max-width: 1199px) {\n    .hero-message-actions-row {\n      width: 80%;\n    }\n  }\n  \n  @media (max-width: 899px) {\n    .hero-message-actions-row {\n      width: 90%;\n    }\n  }\n  \n  @media (max-width: 767px) {\n    .hero-message-actions-row {\n      width: 95%;\n    }\n  }\n  \n  @media (max-width: 599px) {\n    .hero-message-actions-row {\n      width: 98%;\n    }\n  }\n  \n  @media (max-width: 479px) {\n    .hero-message-actions-row {\n      width: 99%;\n    }\n  }\n  \n  .hero-copy-btn, .hero-like-btn, .hero-dislike-btn {\n    background: none;\n    border: none;\n    color: #b0b0b0;\n    font-size: 1.1rem;\n    cursor: pointer;\n    padding: 2px 6px;\n    border-radius: 6px;\n    transition: background 0.18s, color 0.18s;\n    outline: none;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .hero-copy-btn:hover, .hero-like-btn:hover, .hero-dislike-btn:hover,\n  .hero-copy-btn:focus, .hero-like-btn:focus, .hero-dislike-btn:focus {\n    background: #e6f0fa;\n    color: #005ea2;\n  }\n  \n  .hero-like-btn:disabled, .hero-dislike-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n  \n  .hero-feedback-thanks {\n    color: #005ea2;\n    font-size: 0.98rem;\n    margin-left: 8px;\n    opacity: 0;\n    animation: feedback-fadein 0.3s forwards;\n    align-self: center;\n  }\n  \n  @keyframes feedback-fadein {\n    to { opacity: 1; }\n  }\n  \n  .hero-copy-btn-wrapper {\n    position: relative;\n    display: inline-block;\n  }\n  \n  .hero-copied-tooltip {\n    position: absolute;\n    left: 50%;\n    top: 120%;\n    transform: translateX(-50%) translateY(0);\n    background: #005ea2;\n    color: #fff;\n    padding: 3px 9px;\n    border-radius: 6px;\n    font-size: 0.75rem;\n    font-weight: 500;\n    white-space: nowrap;\n    pointer-events: none;\n    z-index: 10;\n    opacity: 0;\n    animation: copied-fadeup 1.2s;\n  }\n  \n  .hero-tab-btn-content svg {\n    width: 20px;\n    height: 20px;\n    margin-right: 8px;\n    margin-bottom: 3px;\n    vertical-align: middle;\n    display: inline-block;\n  }\n  \n  @keyframes copied-fadeup {\n    0% {\n      opacity: 0;\n      transform: translateX(-50%) translateY(-8px);\n    }\n    20% {\n      opacity: 1;\n      transform: translateX(-50%) translateY(0);\n    }\n    80% {\n      opacity: 1;\n      transform: translateX(-50%) translateY(0);\n    }\n    100% {\n      opacity: 0;\n      transform: translateX(-50%) translateY(8px);\n    }\n  }\n  \n  @keyframes expandDown {\n    0% {\n      opacity: 0;\n      transform: scaleY(0);\n      max-height: 0;\n    }\n    100% {\n      opacity: 1;\n      transform: scaleY(1);\n      max-height: 200px;\n    }\n  }\n  \n  /* Large Desktop (1400px and above) */\n  @media (min-width: 1400px) {\n    .hero-message, .hero-message.user, .hero-message.ai {\n      font-size: 1.2rem;\n    }\n    \n    .hero-input-card {\n      width: 70%;\n      max-width: 1500px;\n    }\n\n    .hero-input-card-messages {\n        width: 70%;\n        max-width: 1500px;\n      }\n    \n    .hero-action-buttons {\n      width: 70%;\n      max-width: 1600px;\n    }\n    \n    .hero-empty-chat-headline {\n      font-size: 24px;\n    }\n    \n    .hero-send-btn-messages {\n      font-size: 18px;\n      padding: 0 20px;\n      height: 52px;\n    }\n  }\n  \n  /* Desktop (1200px - 1399px) */\n  @media (max-width: 1399px) and (min-width: 1200px) {\n    \n    .hero-input-card {\n      width: 65%;\n    }\n\n    .hero-input-card-messages {\n        width: 65%;\n    }\n    \n    .hero-action-buttons {\n      width: 75%;\n    }\n    \n    .hero-send-btn-messages {\n      font-size: 16px;\n      padding: 0 18px;\n      height: 50px;\n    }\n  }\n  \n  /* Large Tablet (900px - 1199px) */\n  @media (max-width: 1199px) and (min-width: 900px) {\n    .hero-message, .hero-message.user, .hero-message.ai {\n      padding: 16px 16px;\n      font-size: 1.05rem;\n    }\n  \n    .hero-ai-message-wrapper + .hero-message-actions-row {\n      width: 45% !important;\n    }\n    \n    .hero-input-area {\n      max-width: 85vw;\n    }\n    \n    .hero-input-card {\n      width: 80%;\n      padding: 16px 24px;\n    }\n\n    .hero-input-card-messages {\n        width: 80%;\n        padding: 16px 24px;\n    }\n        \n    .hero-action-buttons {\n      width: 80%;\n      gap: 14px;\n    }\n    \n    .hero-action-btn {\n      padding: 14px 18px;\n      font-size: 0.88rem;\n    }\n    \n    .hero-messages {\n      padding: 8px 0 20px 0;\n    }\n    \n    .hero-message-actions-row {\n      padding: 16px 16px;\n    }\n    \n    .hero-bot-picker-btn {\n      padding: 7px 16px;\n      font-size: 0.98rem;\n    }\n    \n    .hero-empty-chat-headline {\n      font-size: 18px;\n    }\n  }\n  \n  /* Tablet (768px - 899px) */\n  @media (max-width: 899px) and (min-width: 768px) {\n    .hero-message, .hero-message.user, .hero-message.ai {\n      padding: 14px 14px;\n      font-size: 1rem;\n    }\n    \n    .hero-input-area {\n      max-width: 90vw;\n      margin: 0 auto 0 auto;\n      padding: 0 1px;\n    }\n    \n    .hero-chat-input {\n      font-size: 1rem;\n      padding: 14px 12px;\n    }\n    \n    .hero-send-btn {\n      font-size: 1rem;\n      padding: 0 16px;\n      height: 44px;\n    }\n    \n    .hero-send-btn-messages {\n      font-size: 1rem;\n      padding: 0 16px;\n      height: 44px;\n    }\n    \n    .hero-messages {\n      padding: 6px 0 18px 0;\n      gap: 6px;\n      max-width: 99%;\n      align-items: center;\n      overflow-y: auto;\n    }\n    \n    .hero-bot-picker-btn {\n      padding: 6px 12px;\n      font-size: 0.95rem;\n      margin-right: 4px;\n      min-width: 0;\n      height: auto;\n    }\n    \n    .hero-message-actions-row {\n      gap: 6px;\n      font-size: 0.98rem;\n      margin-bottom: 12px;\n      margin-left: 0px;\n      padding: 14px 8vw;\n    }\n    \n    .hero-copy-btn, .hero-like-btn, .hero-dislike-btn {\n      font-size: 1rem;\n      padding: 2px 4px;\n    }\n    \n    .hero-feedback-thanks {\n      font-size: 0.93rem;\n      margin-left: 5px;\n    }\n    \n    .hero-empty-chat-headline {\n      font-size: 1.5rem;\n      margin-top: 7vh;\n      margin-bottom: 28px;\n    }\n    \n    .hero-bot-tooltip {\n      max-width: 250px;\n      font-size: 0.9rem;\n      padding: 6px 12px;\n      width: 250%;\n    }\n    \n    .hero-input-card {\n      padding: 14px 20px;\n    }\n\n    .hero-input-card-messages {\n        padding: 14px 20px;\n    }\n    \n    .hero-action-buttons {\n      width: 90%;\n      gap: 12px;\n    }\n    \n    .hero-action-btn {\n      padding: 12px 16px;\n      font-size: 0.85rem;\n    }\n  }\n  \n  /* Large Mobile (600px - 767px) */\n  @media (max-width: 767px) and (min-width: 600px) {\n    .hero-message, .hero-message.user, .hero-message.ai {\n      padding: 12px 4vw;\n      font-size: 0.98rem;\n    }\n    \n    .hero-message-actions-row {\n      padding: 12px 4vw;\n      font-size: 0.95rem;\n    }\n    \n    .hero-input-area {\n      max-width: 92vw;\n      padding: 0 2px;\n    }\n    \n    .hero-chat-input {\n      font-size: 0.98rem;\n      padding: 12px 10px;\n    }\n    \n    .hero-send-btn {\n      font-size: 0.98rem;\n      padding: 0 12px;\n    }\n    \n    .hero-send-btn-messages {\n      font-size: 0.98rem;\n      padding: 0 12px;\n      height: 44px;\n    }\n    \n    .hero-messages {\n      padding: 6px 0 16px 0;\n    }\n    \n    .hero-bot-picker-btn {\n      padding: 5px 10px;\n      font-size: 0.92rem;\n    }\n    \n    .hero-bot-picker-row {\n      gap: 8px;\n      flex-wrap: wrap;\n    }\n    \n    .hero-message-actions-row {\n      gap: 5px;\n      font-size: 0.95rem;\n      padding: 12px 4vw;\n    }\n    \n    .hero-copy-btn, .hero-like-btn, .hero-dislike-btn {\n      font-size: 0.97rem;\n      padding: 2px 3px;\n    }\n    \n    .hero-empty-chat-headline {\n      font-size: 1.3rem;\n      margin-top: 6vh;\n    }\n    \n    .hero-input-card {\n      padding: 12px 16px;\n    }\n\n    .hero-input-card-messages {\n        padding: 12px 16px;\n    }\n    \n    .hero-action-buttons {\n      width: 95%;\n      gap: 10px;\n    }\n    \n    .hero-action-btn {\n      padding: 11px 14px;\n      font-size: 0.82rem;\n    }\n  }\n  \n  /* Mobile (480px - 599px) */\n  @media (max-width: 599px) and (min-width: 480px) {\n    .hero-message, .hero-message.user, .hero-message.ai {\n      padding: 12px 3vw;\n      font-size: 0.97rem;\n    }\n    \n    .hero-message-actions-row {\n      padding: 12px 3vw;\n      font-size: 0.93rem;\n    }\n    \n    .hero-input-area {\n      max-width: 90vw;\n      margin: 0 auto 0 auto;\n      padding: 0 0.5px;\n    }\n    \n    .hero-chat-input {\n      font-size: 0.97rem;\n      padding: 10px 8px;\n      margin-right: 6px;\n    }\n    \n    .hero-send-btn {\n      font-size: 0.97rem;\n      padding: 0 10px;\n    }\n    \n    .hero-send-btn-messages {\n      font-size: 0.97rem;\n      padding: 0 10px;\n      height: 42px;\n    }\n    \n    .hero-messages {\n      padding: 6px 0 18px 0;\n      align-items: center;\n      width: 99%;\n    }\n    \n    .hero-bot-picker-btn {\n      padding: 4px 8px;\n      font-size: 0.91rem;\n      margin-right: 2px;\n      min-width: 0;\n      height: auto;\n    }\n    \n    .hero-bot-picker-row {\n      padding: 10px 8px 0 8px;\n      gap: 6px;\n      flex-wrap: wrap;\n    }\n    \n    .hero-message-actions-row {\n      gap: 4px;\n      font-size: 0.93rem;\n      margin-bottom: 8px;\n      margin-left: auto;\n      margin-right: auto;\n      padding: 0!important;\n      max-width: 90vw;\n    }\n    \n    .hero-copy-btn, .hero-like-btn, .hero-dislike-btn {\n      font-size: 0.95rem;\n      padding: 1px 2px;\n    }\n    \n    .hero-feedback-thanks {\n      font-size: 0.9rem;\n      margin-left: 3px;\n    }\n    \n    .hero-empty-chat-headline {\n      font-size: 1.15rem;\n      margin-top: 4vh;\n      margin-bottom: 18px;\n    }\n    \n    .hero-bot-tooltip {\n      max-width: 250px;\n      font-size: 0.75rem;\n      padding: 5px 10px;\n      top: 110%;\n      width: 150%;\n    }\n    \n    .hero-input-card {\n      padding: 10px 12px;\n    }\n\n    .hero-input-card-messages {\n        padding: 10px 12px;\n    }\n    \n    .hero-action-buttons {\n      width: 98%;\n      gap: 8px;\n    }\n    \n    .hero-action-btn {\n      padding: 10px 12px;\n      font-size: 0.8rem;\n    }\n  }\n  \n  /* Small Mobile (320px - 479px) */\n  @media (max-width: 479px) and (min-width: 320px) {\n    .hero-message, .hero-message.user, .hero-message.ai {\n      padding: 10px 2vw;\n      font-size: 0.95rem;\n    }\n    \n    .hero-message-actions-row {\n      padding: 10px 2vw;\n      font-size: 0.9rem;\n    }\n    \n    .hero-input-area {\n      max-width: 88vw;\n      padding: 0 1px;\n    }\n    \n    .hero-chat-input {\n      font-size: 0.95rem;\n      padding: 8px 6px;\n      margin-right: 4px;\n    }\n    \n    .hero-send-btn {\n      font-size: 0.95rem;\n      padding: 0 8px;\n    }\n    \n    .hero-send-btn-messages {\n      font-size: 0.95rem;\n      padding: 0 8px;\n      height: 40px;\n    }\n    \n    .hero-messages {\n      padding: 4px 0 14px 0;\n    }\n    \n    .hero-bot-picker-btn {\n      padding: 3px 6px;\n      font-size: 0.88rem;\n      margin-right: 1px;\n    }\n    \n    .hero-bot-picker-row {\n      padding: 8px 6px 0 6px;\n      gap: 4px;\n    }\n    \n    .hero-message-actions-row {\n      gap: 3px;\n      font-size: 0.9rem;\n      padding: 10px 2vw;\n    }\n    \n    .hero-copy-btn, .hero-like-btn, .hero-dislike-btn {\n      font-size: 0.92rem;\n      padding: 1px 1px;\n    }\n    \n    .hero-empty-chat-headline {\n      font-size: 1rem;\n      margin-top: 3vh;\n      margin-bottom: 16px;\n    }\n    \n    .hero-input-card {\n      padding: 8px 10px;\n    }\n\n    .hero-input-card-messages {\n      padding: 8px 10px;\n    }\n    \n    .hero-action-buttons {\n      width: 100%;\n      gap: 6px;\n    }\n    \n    .hero-action-btn {\n      padding: 8px 10px;\n      font-size: 0.78rem;\n      min-height: 60px;\n    }\n    \n    .hero-action-btn span {\n      font-size: 0.72rem;\n    }\n    \n    .hero-example-item {\n      padding: 6px 10px;\n      font-size: 0.72rem;\n    }\n  }\n  \n  /* Extra Small Mobile (below 320px) */\n  @media (max-width: 319px) {\n    .hero-message, .hero-message.user, .hero-message.ai {\n      padding: 8px 1vw;\n      font-size: 0.9rem;\n    }\n    \n    .hero-message-actions-row {\n      padding: 8px 1vw;\n      font-size: 0.85rem;\n    }\n    \n    .hero-input-area {\n      max-width: 85vw;\n    }\n    \n    .hero-chat-input {\n      font-size: 0.9rem;\n      padding: 6px 4px;\n    }\n    \n    .hero-send-btn {\n      font-size: 0.9rem;\n    }\n    \n    .hero-send-btn-messages {\n      font-size: 0.9rem;\n      padding: 0 6px;\n      height: 38px;\n    }\n    \n    .hero-bot-picker-btn {\n      padding: 2px 4px;\n      font-size: 0.85rem;\n    }\n    \n    .hero-empty-chat-headline {\n      font-size: 0.9rem;\n      margin-top: 2vh;\n    }\n    \n    .hero-input-card {\n      padding: 6px 8px;\n    }\n\n    .hero-input-card-messages {\n        padding: 6px 8px;\n      }\n    \n    .hero-action-btn {\n      padding: 6px 8px;\n      font-size: 0.75rem;\n      min-height: 50px;\n    }\n    \n    .hero-action-btn span {\n      font-size: 0.7rem;\n    }\n    \n    .hero-example-item {\n      padding: 4px 8px;\n      font-size: 0.7rem;\n    }\n  }\n  \n  /* Landscape orientation adjustments for mobile */\n  @media (max-width: 900px) and (orientation: landscape) {\n    .hero-empty-center-wrapper {\n      min-height: 70vh;\n      padding-top: 10vh;\n    }\n    \n    .hero-empty-chat-headline {\n      font-size: 1.2rem;\n      margin-top: 2vh;\n      margin-bottom: 12px;\n    }\n    \n    .hero-bot-picker-row {\n      margin-top: 16px;\n      margin-bottom: 12px;\n    }\n    \n    .hero-messages {\n      padding: 4px 0 12px 0;\n    }\n    \n    .hero-input-area.with-messages {\n      margin-top: 8px;\n      margin-bottom: 8px;\n    }\n  }\n  \n  /* High DPI displays */\n  @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {\n    .hero-chat-input, .hero-send-btn, .hero-bot-picker-btn, .hero-action-btn {\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n    }\n  }\n  \n  /* Reduced motion for accessibility */\n  @media (prefers-reduced-motion: reduce) {\n    .hero-chat-area,\n    .hero-message,\n    .hero-input-area,\n    .hero-chat-input,\n    .hero-send-btn,\n    .hero-bot-picker-btn,\n    .hero-action-btn,\n    .hero-typing-indicator .hero-dot,\n    .hero-expanded-examples {\n      transition: none;\n      animation: none;\n    }\n    \n    .hero-typing-indicator .hero-dot {\n      animation: none;\n    }\n  }\n  \n  /* Markdown formatting styles */\n  .hero-markdown-content {\n    width: 100%;\n  }\n  \n  .hero-markdown-paragraph {\n    margin-bottom: 0px;\n    line-height: 1.5;\n    font-size: 16px;\n  }\n  \n  .hero-markdown-heading {\n    margin-top: 18px;\n    margin-bottom: 16px;\n    font-weight: 600;\n    line-height: 1.25;\n  }\n  \n  .hero-markdown-heading:first-child {\n    margin-top: 0;\n  }\n  \n  h1.hero-markdown-heading {\n    font-size: 19px;\n  }\n  \n  h2.hero-markdown-heading {\n    font-size: 18px;\n  }\n  \n  h3.hero-markdown-heading {\n    font-size: 17px;\n  }\n  \n  .hero-markdown-list, .hero-markdown-ordered-list {\n    margin-bottom: 16px;\n    padding-left: 2em;\n    font-size: 16px;\n  }\n  \n  .hero-markdown-list-item {\n    margin-bottom: 6px;\n  }\n  \n  .hero-markdown-divider {\n    height: 0.25em;\n    margin: 24px 0;\n    background-color: rgba(0, 0, 0, 0.1);\n    border: 0;\n  }\n  \n  .hero-markdown-blockquote {\n    padding: 0 1em;\n    margin-left: 0;\n    margin-right: 0;\n    color: #6a737d;\n    border-left: 0.25em solid #dfe2e5;\n  }\n  \n  .hero-markdown-code-block {\n    padding: 16px;\n    overflow: auto;\n    font-size: 85%;\n    line-height: 1.45;\n    background-color: #f6f8fa;\n    border-radius: 3px;\n    margin-bottom: 16px;\n    white-space: pre-wrap;\n  }\n  \n  /* Dark theme adjustments */\n  .hero-message.ai .hero-markdown-code-block {\n    background-color: #2d333b;\n    color: #e6edf3;\n  }\n  \n  .hero-message.ai .hero-markdown-blockquote {\n    border-left-color: #444c56;\n    color: #adbac7;\n  }\n  \n  .hero-message.ai .hero-markdown-divider {\n    background-color: rgba(255, 255, 255, 0.1);\n  }\n  \n  /* Add styles for message actions alignment */\n  .hero-message.user + .hero-message-actions-row {\n    justify-content: end;\n  }\n  \n  .hero-ai-message-wrapper + .hero-message-actions-row {\n    justify-content: center;\n    width: 55%;\n    margin-left: 0px; /* Align with AI message content (avatar width + gap) */\n  }\n  \n  .hero-input-card {\n    background-color: rgba(255, 255, 255, 0.2);\n    backdrop-filter: blur(4px);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    border-radius: 24px;\n    box-shadow: 0 2px 16px rgba(23,32,43,0.06);\n    padding: 12px 32px 12px 32px;\n    width: 60%;\n    max-width: 1300px;\n    margin: 0 auto 0 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    position: relative;\n    z-index: 2;\n  }\n\n  .hero-input-card-messages {\n    background: rgba(249, 249, 249, 1);\n    backdrop-filter: blur(4px);\n    border: 1px solid rgba(213, 213, 213, 1);\n    border-radius: 24px;\n    box-shadow: 0 2px 16px rgba(23,32,43,0.06);\n    padding: 12px 32px 12px 32px;\n    width: 60%;\n    max-width: 1300px;\n    margin: 0 auto 0 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    position: relative;\n    z-index: 2;\n  }\n  \n  /* Responsive width adjustments for input card */\n  @media (max-width: 1199px) {\n    .hero-input-card {\n      width: 80%;\n    }\n    .hero-input-card-messages {\n        width: 80%;\n      }\n  }\n  \n  @media (max-width: 899px) {\n    .hero-input-card {\n      width: 90%;\n    }\n    .hero-input-card-messages {\n        width: 90%;\n      }\n  }\n  \n  @media (max-width: 767px) {\n    .hero-input-card {\n      width: 95%;\n    }\n    .hero-input-card-messages {\n        width: 95%;\n      }\n  }\n  \n  @media (max-width: 599px) {\n    .hero-input-card {\n      width: 98%;\n    }\n    .hero-input-card-messages {\n        width: 98%;\n      }\n  }\n  \n  @media (max-width: 479px) {\n    .hero-input-card {\n      width: 99%;\n    }\n    .hero-input-card-messages {\n        width: 99%;\n      }\n  }\n  \n  .hero-tab-buttons {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 18px;\n    margin-top: 18px;\n  }\n  \n  .hero-tab-btn {\n    background-color: transparent;\n    color: #fff;\n    border: 1px solid rgba(255, 255, 255, 0.2) !important;\n    border-radius: 10px;\n    padding: 8px 16px;\n    font-size: 1rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background 0.18s, color 0.18s, box-shadow 0.18s;\n  }\n  \n  .hero-tab-btn.active {\n    background: #fff;\n    color: #787878;\n    font-weight: 500;\n    box-shadow: 0 4px 16px rgba(47,128,237,0.10);\n  }\n  \n  .hero-tab-btn:hover {\n    font-weight: 500;\n    box-shadow: 0 4px 16px rgba(47,128,237,0.30);\n  }\n\n  .hero-tab-btn-messages {\n    background: rgba(255, 255, 255, 1);\n    color: rgba(135, 135, 135, 1);\n    border: none;\n    border-radius: 10px;\n    padding: 8px 16px;\n    font-size: 1rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background 0.18s, color 0.18s, box-shadow 0.18s;\n  }\n\n  .hero-tab-btn-messages.active {\n    background: rgba(38, 84, 255, 0.1);\n    color: rgba(19, 40, 118, 1);\n    font-weight: 500;\n    box-shadow: 0 4px 16px rgba(47,128,237,0.10);\n  }\n\n  .hero-tab-btn-messages:hover {\n    font-weight: 500;\n    box-shadow: 0 4px 16px rgba(47,128,237,0.30);\n  }\n  \n  .hero-input-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n  }\n  \n  .hero-input-card .hero-chat-input {\n    flex: 1;\n    padding: 18px 0px;\n    border-radius: 18px;\n    border: none !important;\n    background: none;\n    font-size: 16px;\n    font-weight: 700;\n    font-family: 'Gilroy', sans-serif;\n    outline: none;\n    transition: border 0.2s, box-shadow 0.2s;\n    box-shadow: none !important;\n    min-width: 0;\n    caret-color: #fff;\n    color: #fff;\n  }\n  \n  .hero-input-card .hero-chat-input::placeholder {\n    font-weight: 400;\n    font-size: 16px;\n    padding: 0;\n    color: #fff;\n  }\n  \n  .hero-input-card .hero-chat-input:focus {\n    background: none;\n  }\n\n  .hero-input-card-messages .hero-chat-input {\n    flex: 1;\n    padding: 18px 0px;\n    border-radius: 18px;\n    border: none !important;\n    background: rgba(249, 249, 249, 1);\n    font-size: 16px;\n    font-weight: 700;\n    font-family: 'Gilroy', sans-serif;\n    outline: none;\n    transition: border 0.2s, box-shadow 0.2s;\n    box-shadow: none !important;\n    min-width: 0;\n    caret-color: rgba(174, 174, 174, 1);\n    color: #747576;\n  }\n  \n  .hero-input-card-messages .hero-chat-input::placeholder {\n    font-weight: 400;\n    font-size: 16px;\n    padding: 0;\n  }\n  \n  .hero-input-card-messages .hero-chat-input:focus {\n    background: rgba(249, 249, 249, 1);\n  }\n  \n  .hero-send-btn {\n    background: #fff;\n    color:#000;\n    border: none;\n    border-radius: 23px !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background 0.2s, color 0.2s, box-shadow 0.2s;\n    box-shadow: 0 2px 8px rgba(23,32,43,0.06);\n  }\n  \n  .hero-send-btn:disabled {\n    cursor: not-allowed;\n  }\n  \n  .hero-send-btn:hover:not(:disabled), .hero-send-btn:focus:not(:disabled) {\n    background: #fff;\n    color: #000;\n  }\n\n  .hero-send-btn-messages {\n    background: rgba(38, 84, 255, 0.1);\n    color:rgba(19, 39, 117, 1);\n    border: none;\n    border-radius: 23px !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background 0.2s, color 0.2s, box-shadow 0.2s;\n    padding: 0 16px;\n    height: 48px;\n  }\n  \n  .hero-send-btn-messages:disabled {\n    cursor: not-allowed;\n  }\n  \n  .hero-send-btn-messages:hover:not(:disabled), .hero-send-btn-messages:focus:not(:disabled) {\n    box-shadow: 0 2px 8px rgba(23,32,43,0.06);\n  }\n  \n  /* Medium Tablet and below (700px and below) - Enhanced responsive design */\n  @media (max-width: 700px) {\n    .hero-input-card {\n      padding: 18px 8px 14px 8px;\n    }\n\n    .hero-input-card-messages {\n        padding: 18px 8px 14px 8px;\n      }\n    \n    .hero-tab-buttons {\n      gap: 6px;\n      margin-bottom: 10px;\n    }\n    \n    .hero-input-card .hero-chat-input {\n      padding: 14px 10px;\n      font-size: 1rem;\n    }\n\n    .hero-input-card-messages .hero-chat-input {\n        padding: 14px 10px;\n        font-size: 1rem;\n      }\n    \n    .hero-send-btn {\n      font-size: 1rem;\n    }\n    \n    .hero-send-btn-messages {\n      font-size: 1rem;\n      padding: 0 14px;\n      height: 44px;\n    }\n    \n    .hero-action-buttons {\n      width: 95%;\n      gap: 10px;\n      margin-top: 18px;\n      margin-bottom: 10px;\n    }\n    \n    .hero-action-btn {\n      padding: 12px 14px;\n      font-size: 0.83rem;\n      min-height: 65px;\n    }\n    \n    .hero-action-btn span {\n      font-size: 0.78rem;\n    }\n    \n    .hero-example-item {\n      padding: 9px 14px;\n      font-size: 0.78rem;\n    }\n    \n    .hero-message, .hero-message.user, .hero-message.ai {\n      padding: 13px 6vw;\n      font-size: 0.99rem;\n    }\n    \n    .hero-message-actions-row {\n      padding: 13px 6vw;\n    }\n    \n    .hero-input-area {\n      max-width: 92vw;\n    }\n    \n    .hero-chat-input {\n      font-size: 0.99rem;\n      padding: 12px 10px;\n    }\n    \n    .hero-bot-picker-btn {\n      padding: 6px 11px;\n      font-size: 0.93rem;\n    }\n    \n    .hero-empty-chat-headline {\n      font-size: 1.4rem;\n      margin-top: 6vh;\n    }\n  }\n  \n  .hero-action-buttons {\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    gap: 16px;\n    margin-top: 24px;\n    margin-bottom: 16px;\n    width: 78%;\n    max-width: 1400px;\n    margin-left: auto;\n    margin-right: auto;\n    overflow: visible;\n    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n    opacity: 1;\n    transform: translateY(0);\n  }\n  \n  .hero-action-buttons.fading {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  \n  .hero-action-buttons:not(.expanded) {\n    align-content:baseline; \n  }\n  \n  .hero-action-btn {\n    background: rgba(255, 255, 255, 0.1);\n    backdrop-filter: blur(4px);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    border-radius: 12px;\n    padding: 16px 20px;\n    font-size: 0.9rem;\n    font-weight: 500;\n    color: #AEAEAE;\n    cursor: pointer;\n    transition: background 0.3s ease, border 0.3s ease, box-shadow 0.3s ease, scale 0.3s ease, border-radius 0.3s ease;\n    outline: none;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex: 1;\n    min-height: 70px;\n    width: 100%;\n    text-align: left;\n    line-height: 1.4;\n  }\n  \n  .hero-action-btn.expanded {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  }\n  \n  .hero-action-btn:hover {\n    box-shadow: 0 8px 32px rgba(23,32,43,0.08);\n  }\n  \n  .hero-action-btn span {\n    flex: 1;\n    font-size: 0.85rem;\n    line-height: 1.3;\n    color: #fff;\n  }\n  \n  .hero-action-btn svg {\n    color: #132876;\n  }\n  \n  .hero-action-btn-container {\n    position: relative;\n    flex: 1;\n    max-width: 78%;\n    overflow: visible;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .hero-dropdown-arrow {\n    transition: transform 0.3s ease;\n    color: #AEAEAE;\n    flex-shrink: 0;\n  }\n  \n  .hero-dropdown-arrow.rotated {\n    transform: rotate(180deg);\n  }\n  \n  .hero-expanded-examples {\n    width: 100%;\n    background: rgba(255, 255, 255, 0.1);\n    backdrop-filter: blur(4px);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    border-top: none;\n    border-radius: 0 0 12px 12px;\n    overflow: hidden;\n    margin-top: 0;\n    position: static;\n    box-shadow: 0 4px 16px rgba(23,32,43,0.08);\n    animation: expandDown 0.3s ease-out;\n    transform-origin: top;\n  }\n  \n  .hero-example-item {\n    width: 100%;\n    padding: 12px 20px;\n    background: none;\n    border: none;\n    text-align: left;\n    font-size: 0.9rem;\n    color: #AEAEAE;\n    cursor: pointer;\n    transition: background 0.3s ease, color 0.3s ease, transform 0.2s ease;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n    line-height: 1.4;\n  }\n  \n  .hero-example-item:last-child {\n    border-bottom: none;\n  }\n  \n  .hero-example-item:hover {\n    transform: translateX(4px);\n  }\n  \n  .hero-example-item:focus {\n    color: #132775;\n    outline: none;\n    transform: translateX(4px);\n  }\n  \n  .hero-example-item:active {\n    color: #132775;\n    transform: translateX(4px) scale(0.98);\n  }\n  \n  /* Tablet and below (900px and below) - Action buttons responsive design */\n  @media (max-width: 900px) {\n    .hero-action-buttons {\n      gap: 12px;\n      margin-top: 20px;\n      margin-bottom: 12px;\n      padding: 0 16px;\n      width: 90%;\n    }\n    \n    .hero-action-btn {\n      padding: 12px 16px;\n      font-size: 0.85rem;\n      max-width: 180px;\n      min-height: 68px;\n    }\n    \n    .hero-action-btn span {\n      font-size: 0.8rem;\n    }\n    \n    .hero-expanded-examples {\n      margin-top: 0;\n    }\n    \n    .hero-example-item {\n      padding: 10px 16px;\n      font-size: 0.8rem;\n    }\n    \n    .hero-action-btn-container {\n      max-width: 90%;\n    }\n  }\n  \n  /* Mobile and below (600px and below) - Enhanced responsive design */\n  @media (max-width: 600px) {\n    .hero-action-buttons {\n      flex-direction: column;\n      gap: 8px;\n      margin-top: 16px;\n      margin-bottom: 8px;\n      padding: 0 8px;\n    }\n    \n    .hero-action-btn {\n      padding: 10px 14px;\n      font-size: 0.8rem;\n      max-width: 100%;\n      width: 100%;\n    }\n    \n    .hero-action-btn span {\n      font-size: 0.75rem;\n    }\n    \n    .hero-expanded-examples {\n      margin-top: 0;\n    }\n    \n    .hero-example-item {\n      padding: 8px 14px;\n      font-size: 0.75rem;\n    }\n    \n    /* Additional mobile optimizations */\n    .hero-input-card {\n      padding: 12px 16px;\n    }\n    \n    .hero-input-card-messages {\n        padding: 12px 16px;\n      }\n    \n    .hero-tab-buttons {\n      gap: 4px;\n      margin-bottom: 8px;\n    }\n    \n    .hero-tab-btn {\n      padding: 6px 12px;\n      font-size: 0.9rem;\n    }\n\n    .hero-tab-btn-messages {\n        padding: 6px 12px;\n        font-size: 0.9rem;\n      }\n    \n    .hero-input-card .hero-chat-input {\n      padding: 12px 8px;\n      font-size: 0.95rem;\n    }\n\n    .hero-input-card-messages .hero-chat-input {\n        padding: 12px 8px;\n        font-size: 0.95rem;\n      }\n    \n    .hero-send-btn {\n      font-size: 0.95rem;\n    }\n    \n    .hero-send-btn-messages {\n      font-size: 0.95rem;\n      padding: 0 12px;\n      height: 42px;\n    }\n    \n    .hero-message, .hero-message.user, .hero-message.ai {\n      padding: 12px 12px;\n      font-size: 0.96rem;\n    }\n    \n    .hero-message-actions-row {\n      padding: 12px 3vw;\n    }\n    \n    .hero-input-area {\n      max-width: 92vw;\n      padding: 0 2px;\n    }\n    \n    .hero-chat-input {\n      font-size: 0.96rem;\n      padding: 10px 8px;\n    }\n    \n    .hero-messages {\n      padding: 6px 0 16px 0;\n    }\n    \n    .hero-bot-picker-btn {\n      padding: 5px 10px;\n      font-size: 0.9rem;\n    }\n    \n    .hero-message-actions-row {\n      gap: 4px;\n      font-size: 0.94rem;\n      padding: 12px 3vw;\n    }\n    \n    .hero-copy-btn, .hero-like-btn, .hero-dislike-btn {\n      font-size: 0.94rem;\n      padding: 2px 3px;\n    }\n    \n    .hero-empty-chat-headline {\n      font-size: 1.2rem;\n      margin-top: 5vh;\n    }\n  }\n  \n  /* Touch device optimizations */\n  @media (hover: none) and (pointer: coarse) {\n    .hero-copy-btn, .hero-like-btn, .hero-dislike-btn {\n      min-height: 44px;\n      min-width: 44px;\n      padding: 8px 12px;\n    }\n    \n    .hero-bot-picker-btn {\n      min-height: 44px;\n      padding: 8px 16px;\n    }\n    \n    .hero-send-btn {\n      min-height: 44px;\n      min-width: 44px;\n    }\n    \n    .hero-send-btn-messages {\n      min-height: 44px;\n      min-width: 44px;\n    }\n    \n    .hero-action-btn {\n      min-height: 60px;\n    }\n    \n    .hero-tab-btn {\n      min-height: 44px;\n      padding: 10px 20px;\n    }\n\n    .hero-tab-btn-messages {\n        min-height: 44px;\n        padding: 10px 20px;\n      }\n    \n    .hero-example-item {\n      min-height: 44px;\n      padding: 12px 20px;\n    }\n  }\n  \n  /* High contrast mode support */\n  @media (prefers-contrast: high) {\n    .hero-message.user {\n      border: 2px solid #17202B;\n    }\n    \n    .hero-chat-input {\n      border: 2px solid #17202B;\n    }\n    \n    .hero-send-btn {\n      border: 2px solid #132775;\n    }\n    \n    .hero-action-btn {\n      border: 1px solid rgba(255, 255, 255, 0.2);\n    }\n    \n    .hero-bot-picker-btn {\n      border: 2px solid #2F80ED;\n    }\n  }\n  \n  /* Print styles */\n  @media print {\n    .hero-chat-area {\n      background: white !important;\n      color: black !important;\n    }\n    \n    .hero-input-area,\n    .hero-send-btn,\n    .hero-action-buttons,\n    .hero-bot-picker-row {\n      display: none !important;\n    }\n    \n    .hero-message {\n      break-inside: avoid;\n      page-break-inside: avoid;\n    }\n  }\n  \n  /* Focus visible for better accessibility */\n  .hero-copy-btn:focus-visible,\n  .hero-like-btn:focus-visible,\n  .hero-dislike-btn:focus-visible,\n  .hero-send-btn:focus-visible,\n  .hero-bot-picker-btn:focus-visible,\n  .hero-action-btn:focus-visible,\n  .hero-example-item:focus-visible {\n    outline: 2px solid #2F80ED;\n    outline-offset: 2px;\n  }\n  \n  /* Improved scrolling for mobile */\n  @media (max-width: 900px) {\n    .hero-messages {\n      -webkit-overflow-scrolling: touch;\n      scroll-behavior: smooth;\n    }\n    \n    .hero-chat-input {\n      -webkit-appearance: none;\n      border-radius: 24px;\n    }\n    \n    .hero-send-btn {\n      -webkit-tap-highlight-color: transparent;\n    }\n  }\n  \n  /* Landscape phone optimizations */\n  @media (max-width: 900px) and (orientation: landscape) and (max-height: 500px) {\n    .hero-empty-center-wrapper {\n      min-height: 60vh;\n      padding-top: 5vh;\n    }\n    \n    .hero-empty-chat-headline {\n      font-size: 1rem;\n      margin-top: 2vh;\n      margin-bottom: 8px;\n    }\n    \n    .hero-bot-picker-row {\n      margin-top: 8px;\n      margin-bottom: 8px;\n    }\n    \n    .hero-messages {\n      padding: 2px 0 8px 0;\n    }\n    \n    .hero-input-area.with-messages {\n      margin-top: 4px;\n      margin-bottom: 4px;\n    }\n    \n    .hero-action-buttons {\n      margin-top: 8px;\n      margin-bottom: 6px;\n    }\n    \n    .hero-action-btn {\n      min-height: 50px;\n      padding: 8px 12px;\n    }\n  }\n  \n  /* Ultra-wide screen support */\n  @media (min-width: 2000px) {\n    .hero-message, .hero-message.user, .hero-message.ai {\n      max-width: 1300px;\n      font-size: 1.3rem;\n    }\n    \n    .hero-input-card {\n      width: 60%;\n      max-width: 1600px;\n    }\n\n    .hero-input-card-messages {\n        width: 60%;\n        max-width: 1600px;\n      }\n    \n    .hero-action-buttons {\n      width: 60%;\n      max-width: 1800px;\n    }\n    \n    .hero-empty-chat-headline {\n      font-size: 28px;\n    }\n    \n    .hero-bot-picker-btn {\n      font-size: 1.1rem;\n      padding: 10px 24px;\n    }\n    \n    .hero-chat-input {\n      font-size: 1.2rem;\n      padding: 24px 0px;\n    }\n    \n    .hero-send-btn {\n      font-size: 18px;\n    }\n    \n    .hero-send-btn-messages {\n      font-size: 18px;\n      padding: 0 20px;\n      height: 52px;\n    }\n  }\n  \n  .hero-ai-message-row {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .hero-ai-message-wrapper {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    margin-bottom: 16px;\n    justify-content: flex-start;\n    width: 60%;\n    max-width: 1300px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  \n  /* Responsive width adjustments for AI message wrapper */\n  @media (max-width: 1199px) {\n    .hero-ai-message-wrapper {\n      width: 80%;\n    }\n  }\n  \n  @media (max-width: 899px) {\n    .hero-ai-message-wrapper {\n      width: 90%;\n    }\n  }\n  \n  @media (max-width: 767px) {\n    .hero-ai-message-wrapper {\n      width: 95%;\n    }\n  }\n  \n  @media (max-width: 599px) {\n    .hero-ai-message-wrapper {\n      width: 98%;\n    }\n  }\n  \n  @media (max-width: 479px) {\n    .hero-ai-message-wrapper {\n      width: 99%;\n    }\n  }\n  \n  .hero-ai-avatar-wrapper{\n    width: 45px;\n    height: 45px;\n    background: #2654FF1A;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 8px;\n    flex-shrink: 0;\n  }\n  \n  .hero-ai-avatar{\n    width: 20px;\n    height: 20px;\n    object-fit: contain;\n  }\n  \n  /* Responsive avatar adjustments */\n  @media (max-width: 1199px) {\n    .hero-ai-avatar-wrapper {\n      width: 42px;\n      height: 42px;\n    }\n    \n    .hero-ai-avatar {\n      width: 18px;\n      height: 18px;\n    }\n  }\n  \n  @media (max-width: 899px) {\n    .hero-ai-avatar-wrapper {\n      width: 40px;\n      height: 40px;\n    }\n    \n    .hero-ai-avatar {\n      width: 17px;\n      height: 17px;\n    }\n  }\n  \n  @media (max-width: 767px) {\n    .hero-ai-avatar-wrapper {\n      width: 38px;\n      height: 38px;\n    }\n    \n    .hero-ai-avatar {\n      width: 16px;\n      height: 16px;\n    }\n  }\n  \n  @media (max-width: 599px) {\n    .hero-ai-avatar-wrapper {\n      width: 36px;\n      height: 36px;\n    }\n    \n    .hero-ai-avatar {\n      width: 15px;\n      height: 15px;\n    }\n  }\n  \n  @media (max-width: 479px) {\n    .hero-ai-avatar-wrapper {\n      width: 34px;\n      height: 34px;\n    }\n    \n    .hero-ai-avatar {\n      width: 14px;\n      height: 14px;\n    }\n  }\n  \n  @media (max-width: 319px) {\n    .hero-ai-avatar-wrapper {\n      width: 32px;\n      height: 32px;\n    }\n    \n    .hero-ai-avatar {\n      width: 13px;\n      height: 13px;\n    }\n  }\n\n  /* Message limit warning styling */\n  .hero-message-limit-warning {\n    background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);\n    color: white;\n    padding: 12px 16px;\n    border-radius: 8px;\n    margin-top: 12px;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 500;\n    box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);\n    animation: warning-pulse 2s ease-in-out infinite;\n  }\n\n  @keyframes warning-pulse {\n    0%, 100% {\n      transform: scale(1);\n      box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);\n    }\n    50% {\n      transform: scale(1.02);\n      box-shadow: 0 6px 16px rgba(255, 107, 107, 0.4);\n    }\n  }\n\n  .hero-message-limit-warning strong {\n    font-weight: 600;\n  }\n\n  /* Disabled state styling for buttons when message limit is reached */\n  .hero-action-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    pointer-events: none;\n  }\n\n  .hero-tab-btn:disabled,\n  .hero-tab-btn-messages:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    pointer-events: none;\n  }\n\n  .hero-chat-input:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    background-color: #f5f5f5;\n  }\n\n  .hero-send-btn:disabled,\n  .hero-send-btn-messages:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    pointer-events: none;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
